export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Uuid: { input: any; output: any; }
};

export type AddProductTechMapPaginated = {
  __typename?: 'AddProductTechMapPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AlternativeUnitGroupInput = {
  alternativeUnit: Scalars['Int']['input'];
  alternativeUnitGroup: Scalars['Int']['input'];
  alternativeValue: Scalars['Int']['input'];
};

export type BookingAllowedDurationProxy = {
  __typename?: 'BookingAllowedDurationProxy';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BookingHistoryDataProxy = {
  __typename?: 'BookingHistoryDataProxy';
  bookingHistory?: Maybe<BookingHistoryProxy>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type BookingHistoryProxy = {
  __typename?: 'BookingHistoryProxy';
  booking?: Maybe<BookingMainProxy>;
  bookingHistoryData?: Maybe<Array<BookingHistoryDataProxy>>;
  changeTime?: Maybe<Scalars['String']['output']>;
  client?: Maybe<ClientProxy>;
  exists: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  user?: Maybe<UserProxy>;
};


export type BookingHistoryProxyChangeTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BookingMainProxy = {
  __typename?: 'BookingMainProxy';
  bookingHistories?: Maybe<Array<BookingHistoryProxy>>;
  bookingSalary?: Maybe<BookingSalaryProxy>;
  branch?: Maybe<BranchProxy>;
  client?: Maybe<ClientProxy>;
  date?: Maybe<Scalars['String']['output']>;
  durationMoreThenGap?: Maybe<Scalars['Boolean']['output']>;
  employee?: Maybe<EmployeeProxy>;
  endTime?: Maybe<Scalars['String']['output']>;
  fromOnline?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isClientFirstAttendance: Scalars['Boolean']['output'];
  isWriteOffCompleted: Scalars['Boolean']['output'];
  needClientRecall: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notificationTime?: Maybe<Scalars['String']['output']>;
  notificationTimeTs: Scalars['Int']['output'];
  operationNumberForWriteOff?: Maybe<Scalars['Uuid']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  review?: Maybe<ReviewProxy>;
  salaryPayments?: Maybe<SalaryPaymentPaginated>;
  saleActionDate?: Maybe<Scalars['String']['output']>;
  saleActionProductsAmount?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<ServiceProxy>;
  status?: Maybe<BookingStatusProxy>;
  technologicalMaps?: Maybe<Array<TechnologicalMapProxy>>;
  time?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['Uuid']['output'];
};


export type BookingMainProxyBookingHistoriesArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BookingMainProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxySalaryPaymentsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxySaleActionDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingMainProxyTechnologicalMapsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BookingMainProxyTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BookingModuleConfigProxy = {
  __typename?: 'BookingModuleConfigProxy';
  allowedDuration?: Maybe<BookingAllowedDurationProxy>;
  company?: Maybe<CompanyProxy>;
  confirmationCall: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  onlineBooking: Scalars['Boolean']['output'];
};

export type BookingPaginated = {
  __typename?: 'BookingPaginated';
  bookings?: Maybe<Array<BookingMainProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BookingProxy = {
  __typename?: 'BookingProxy';
  branch: BranchProxy;
  client: Client;
  date: Scalars['String']['output'];
  employee: EmployeeBookingProxy;
  endTime: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  notificationTime?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  service: ServiceBookingProxy;
  status: Scalars['String']['output'];
  time: Scalars['String']['output'];
  uuid: Scalars['Uuid']['output'];
};


export type BookingProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingProxyNotificationTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingProxyTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BookingSalaryProxy = {
  __typename?: 'BookingSalaryProxy';
  booking?: Maybe<BookingProxy>;
  id: Scalars['Int']['output'];
  salaryType?: Maybe<Scalars['Int']['output']>;
  salaryValue?: Maybe<Scalars['Float']['output']>;
};

export type BookingStatusProxy = {
  __typename?: 'BookingStatusProxy';
  bookings?: Maybe<BookingPaginated>;
  colorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type BookingStatusProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingTime = {
  __typename?: 'BookingTime';
  end: Scalars['String']['output'];
  start: Scalars['String']['output'];
};


export type BookingTimeEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BookingTimeStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type Branch = {
  __typename?: 'Branch';
  address: Scalars['String']['output'];
  city?: Maybe<City>;
  closestBookingDate?: Maybe<Scalars['String']['output']>;
  closestBookingDateDefaultEmployee?: Maybe<Scalars['String']['output']>;
  closestBookingTimes?: Maybe<Array<BookingTime>>;
  closestBookingTimesDefaultEmployee?: Maybe<Array<BookingTime>>;
  country: Country;
  currencyCode: Scalars['String']['output'];
  dateTimeFormat?: Maybe<DateTimeFormat>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Language>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  phoneCode?: Maybe<Scalars['String']['output']>;
  serviceImages: Array<Scalars['String']['output']>;
  website: Scalars['String']['output'];
  workSchedule?: Maybe<Scalars['String']['output']>;
};


export type BranchClosestBookingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BranchClosestBookingDateDefaultEmployeeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type BranchConfigInput = {
  branch: Scalars['Int']['input'];
  jsConfig?: InputMaybe<Scalars['String']['input']>;
};

export type BranchDetailsProxy = {
  __typename?: 'BranchDetailsProxy';
  branch: BranchProxy;
  formatedAddress?: Maybe<Scalars['String']['output']>;
  googleMapUri?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maxPrice?: Maybe<Scalars['Int']['output']>;
  minPrice?: Maybe<Scalars['Int']['output']>;
  priceLevel?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  utcOffsetMinutes: Scalars['Int']['output'];
};

export type BranchInput = {
  address: Scalars['String']['input'];
  category: CompanyTypeEnum;
  city?: InputMaybe<Scalars['Int']['input']>;
  country: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  isUpdateGallery?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateLogo?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['Int']['input']>>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  otherCity?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<BranchPhoneInput>>;
  primaryLanguage?: InputMaybe<Scalars['Int']['input']>;
  socialLink?: InputMaybe<BranchSocialLinkInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<Scalars['String']['input']>;
  workSchedules?: InputMaybe<Array<BranchWorkScheduleInput>>;
};

export type BranchMultipleConfigUpdateInput = {
  configs: Array<BranchConfigInput>;
};

export type BranchPaginated = {
  __typename?: 'BranchPaginated';
  branches?: Maybe<Array<BranchProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  isCanCreateNewBranch: Scalars['Boolean']['output'];
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type BranchPhoneInput = {
  phone: Scalars['String']['input'];
};

export type BranchPhoneProxy = {
  __typename?: 'BranchPhoneProxy';
  branch: BranchProxy;
  id: Scalars['Int']['output'];
  phone: Scalars['String']['output'];
};

export type BranchProxy = {
  __typename?: 'BranchProxy';
  activeDeliveryMenu?: Maybe<MenuProxy>;
  activeDineInMenu?: Maybe<MenuProxy>;
  activePickUpMenu?: Maybe<MenuProxy>;
  address: Scalars['String']['output'];
  bookingQrCode: Scalars['String']['output'];
  bookingQrLink: Scalars['String']['output'];
  bookings?: Maybe<BookingPaginated>;
  bookingsList?: Maybe<Array<BookingMainProxy>>;
  branchDetails?: Maybe<BranchDetailsProxy>;
  branchEmployees?: Maybe<Array<EmployeeProxy>>;
  branchImages?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<CompanyTypeProxy>;
  city?: Maybe<CityProxy>;
  closestBookingDate?: Maybe<Scalars['String']['output']>;
  closestBookingDateDefaultEmployee?: Maybe<Scalars['String']['output']>;
  closestBookingTimes?: Maybe<Array<BookingTime>>;
  closestBookingTimesDefaultEmployee?: Maybe<Array<BookingTime>>;
  company?: Maybe<CompanyProxy>;
  country: Country;
  countryProxy?: Maybe<CountryProxy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currencyCode: Scalars['String']['output'];
  customDays?: Maybe<Array<CustomDayProxy>>;
  dateTimeFormat?: Maybe<DateTimeFormatProxy>;
  deleted: Scalars['Boolean']['output'];
  deliveryWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeWorkScheduleSetting?: Maybe<EmployeeWorkScheduleSetting>;
  employees?: Maybe<Array<EmployeeProxy>>;
  employeesPaginated?: Maybe<EmployeePaginated>;
  generalWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAnyActiveServiceEmployeeRelations: Scalars['Boolean']['output'];
  isAnyActiveServices: Scalars['Boolean']['output'];
  isAnyEmployeeWithOnlineBookingOn: Scalars['Boolean']['output'];
  isAnyWorkScheduleForWorkingEmployees: Scalars['Boolean']['output'];
  kitchenWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  language?: Maybe<LanguageProxy>;
  logbookSetting?: Maybe<LogbookSetting>;
  meBookingConfig?: Maybe<MeBookingBranchConfigProxy>;
  menus?: Maybe<MenuPaginated>;
  menusList?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
  onlineRegistration: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<BranchPhoneProxy>>;
  rating?: Maybe<Scalars['Int']['output']>;
  removedOfTariff: Scalars['Boolean']['output'];
  replaceableDeliveryMenus?: Maybe<Array<MenuProxy>>;
  replaceableDineInMenus?: Maybe<Array<MenuProxy>>;
  replaceablePickUpMenus?: Maybe<Array<MenuProxy>>;
  serviceImages?: Maybe<Array<Scalars['String']['output']>>;
  socialLink?: Maybe<BranchSocialLinkProxy>;
  storageProductRelationHistoryList?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  storageProductRelationHistoryPaginated?: Maybe<StorageProductRelationHistoryPaginatedType>;
  storages?: Maybe<Array<StorageProxy>>;
  storagesPaginated?: Maybe<StoragePaginated>;
  suppliers?: Maybe<Array<SupplierProxy>>;
  timeZone: Scalars['String']['output'];
  type?: Maybe<BranchTypeProxy>;
  userBranchRelations?: Maybe<Array<UserBranchRelationProxy>>;
  website?: Maybe<Scalars['String']['output']>;
  workSchedule?: Maybe<Scalars['String']['output']>;
  workSchedules?: Maybe<Array<WorkScheduleProxy>>;
};


export type BranchProxyBookingsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['Uuid']['input']>;
};


export type BranchProxyBookingsListArgs = {
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  uuid?: InputMaybe<Scalars['Uuid']['input']>;
};


export type BranchProxyClosestBookingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyClosestBookingDateDefaultEmployeeArgs = {
  format: Scalars['String']['input'];
};


export type BranchProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyCustomDaysArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyDeliveryWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyEmployeesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BranchProxyEmployeesPaginatedArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filterByNameAndPosition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  positionId?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyGeneralWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyKitchenWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  menuTypeId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyMenusListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  menuTypeId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type BranchProxyPhonesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyStorageProductRelationHistoryListArgs = {
  operationNumber?: InputMaybe<Scalars['Uuid']['input']>;
};


export type BranchProxyStorageProductRelationHistoryPaginatedArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  edited?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  operationNumber?: InputMaybe<Scalars['Uuid']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productCategory?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  remnants?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  storageId?: InputMaybe<Scalars['Int']['input']>;
  supplier?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyStoragesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyStoragesPaginatedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxySuppliersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyUserBranchRelationsArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchProxyWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BranchSocialLinkInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  whatsapp?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type BranchSocialLinkProxy = {
  __typename?: 'BranchSocialLinkProxy';
  branch: BranchProxy;
  facebook?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  whatsapp?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type BranchTypeProxy = {
  __typename?: 'BranchTypeProxy';
  branches?: Maybe<Array<BranchProxy>>;
  childTypes?: Maybe<Array<Maybe<BranchTypeProxy>>>;
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentType?: Maybe<BranchTypeProxy>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type BranchTypeProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type BranchTypeProxyChildTypesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BranchWorkPeriodTypeProxy = {
  __typename?: 'BranchWorkPeriodTypeProxy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  workSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
};


export type BranchWorkPeriodTypeProxyWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BranchWorkScheduleInput = {
  day: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type BranchWorkScheduleProxy = {
  __typename?: 'BranchWorkScheduleProxy';
  branch: BranchProxy;
  day: DayProxy;
  id: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  type: BranchWorkPeriodTypeProxy;
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type City = {
  __typename?: 'City';
  country: Country;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CityPaginated = {
  __typename?: 'CityPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<CityProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CityProxy = {
  __typename?: 'CityProxy';
  country?: Maybe<CountryProxy>;
  custom?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Client = {
  __typename?: 'Client';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneCode?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type ClientAdminBookingInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  patronymic?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['Int']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isUpdateImage?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  patronymic?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type ClientPaginated = {
  __typename?: 'ClientPaginated';
  clients?: Maybe<Array<ClientProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ClientProxy = {
  __typename?: 'ClientProxy';
  bookingHistories?: Maybe<Array<BookingHistoryProxy>>;
  bookings?: Maybe<BookingPaginated>;
  category?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<GenderProxy>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  loyaltyCard?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};


export type ClientProxyBookingHistoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type ClientProxyDateOfBirthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ClientQueryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientSaleUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CompanyType>;
  city: City;
  confirmationCallRequired: Scalars['Boolean']['output'];
  country: Country;
  dateTimeFormat?: Maybe<DateTimeFormat>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language: Language;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  phoneCode?: Maybe<Scalars['String']['output']>;
  showAds: Scalars['Boolean']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum CompanyAccess {
  AccessManageBranchEmployees = 'ACCESS_MANAGE_BRANCH_EMPLOYEES',
  AccessManageCompanyEmployees = 'ACCESS_MANAGE_COMPANY_EMPLOYEES',
  AccessSettingsView = 'ACCESS_SETTINGS_VIEW',
  AdminViewBranch = 'ADMIN_VIEW_BRANCH',
  BookingStatisticViewExport = 'BOOKING_STATISTIC_VIEW_EXPORT',
  BranchCreate = 'BRANCH_CREATE',
  BranchDeleteRestore = 'BRANCH_DELETE_RESTORE',
  BranchEdit = 'BRANCH_EDIT',
  BranchView = 'BRANCH_VIEW',
  CancelBooking = 'CANCEL_BOOKING',
  CheckAllSchedule = 'CHECK_ALL_SCHEDULE',
  ClientsHideContacts = 'CLIENTS_HIDE_CONTACTS',
  ClientsShowContacts = 'CLIENTS_SHOW_CONTACTS',
  ClientCreate = 'CLIENT_CREATE',
  ClientDelete = 'CLIENT_DELETE',
  ClientEdit = 'CLIENT_EDIT',
  ClientExport = 'CLIENT_EXPORT',
  ClientImport = 'CLIENT_IMPORT',
  ClientListView = 'CLIENT_LIST_VIEW',
  CompanyDeleteRestore = 'COMPANY_DELETE_RESTORE',
  CompanyInfoEdit = 'COMPANY_INFO_EDIT',
  CompanyInfoView = 'COMPANY_INFO_VIEW',
  CreateBooking = 'CREATE_BOOKING',
  CreateBranch = 'CREATE_BRANCH',
  CreateClient = 'CREATE_CLIENT',
  CreateEmployee = 'CREATE_EMPLOYEE',
  CreatePosition = 'CREATE_POSITION',
  CreateProduct = 'CREATE_PRODUCT',
  CreateProductCategory = 'CREATE_PRODUCT_CATEGORY',
  CreateReview = 'CREATE_REVIEW',
  CreateService = 'CREATE_SERVICE',
  CreateServiceCategory = 'CREATE_SERVICE_CATEGORY',
  CreateStorage = 'CREATE_STORAGE',
  CreateTechnologicalMap = 'CREATE_TECHNOLOGICAL_MAP',
  CreateTechnologicalMapCategory = 'CREATE_TECHNOLOGICAL_MAP_CATEGORY',
  CustomDayCreate = 'CUSTOM_DAY_CREATE',
  CustomDayDelete = 'CUSTOM_DAY_DELETE',
  CustomDayEdit = 'CUSTOM_DAY_EDIT',
  DeleteBranch = 'DELETE_BRANCH',
  DeleteClient = 'DELETE_CLIENT',
  DeleteCompany = 'DELETE_COMPANY',
  DeletePosition = 'DELETE_POSITION',
  DeleteProduct = 'DELETE_PRODUCT',
  DeleteReview = 'DELETE_REVIEW',
  DeleteTechnologicalMap = 'DELETE_TECHNOLOGICAL_MAP',
  DismissEmployee = 'DISMISS_EMPLOYEE',
  EditBooking = 'EDIT_BOOKING',
  EditBranch = 'EDIT_BRANCH',
  EditClient = 'EDIT_CLIENT',
  EditCompany = 'EDIT_COMPANY',
  EditEmployee = 'EDIT_EMPLOYEE',
  EditPosition = 'EDIT_POSITION',
  EditProduct = 'EDIT_PRODUCT',
  EditProductCategory = 'EDIT_PRODUCT_CATEGORY',
  EditReview = 'EDIT_REVIEW',
  EditSalary = 'EDIT_SALARY',
  EditSchedule = 'EDIT_SCHEDULE',
  EditService = 'EDIT_SERVICE',
  EditServiceCategory = 'EDIT_SERVICE_CATEGORY',
  EditStorage = 'EDIT_STORAGE',
  EditTechnologicalMap = 'EDIT_TECHNOLOGICAL_MAP',
  EditTechnologicalMapCategory = 'EDIT_TECHNOLOGICAL_MAP_CATEGORY',
  EmailBookingCancel = 'EMAIL_BOOKING_CANCEL',
  EmailBookingCreate = 'EMAIL_BOOKING_CREATE',
  EmailBookingEdit = 'EMAIL_BOOKING_EDIT',
  EmailCompanyOrBranchOrOnlineSettingsEdit = 'EMAIL_COMPANY_OR_BRANCH_OR_ONLINE_SETTINGS_EDIT',
  EmailCriticalStock = 'EMAIL_CRITICAL_STOCK',
  EmailReviewWasLeft = 'EMAIL_REVIEW_WAS_LEFT',
  EmailScheduleExpiresSoon = 'EMAIL_SCHEDULE_EXPIRES_SOON',
  EmailSubscriptionExpired = 'EMAIL_SUBSCRIPTION_EXPIRED',
  EmailSubscriptionExpiresSoon = 'EMAIL_SUBSCRIPTION_EXPIRES_SOON',
  EmployeeBookingSettingsEdit = 'EMPLOYEE_BOOKING_SETTINGS_EDIT',
  EmployeeBookingSettingsView = 'EMPLOYEE_BOOKING_SETTINGS_VIEW',
  EmployeeCreate = 'EMPLOYEE_CREATE',
  EmployeeDismiss = 'EMPLOYEE_DISMISS',
  EmployeeEdit = 'EMPLOYEE_EDIT',
  EmployeeEditSelf = 'EMPLOYEE_EDIT_SELF',
  EmployeeExport = 'EMPLOYEE_EXPORT',
  EmployeeImport = 'EMPLOYEE_IMPORT',
  EmployeeListView = 'EMPLOYEE_LIST_VIEW',
  EmployeeServicesEdit = 'EMPLOYEE_SERVICES_EDIT',
  EmployeeServicesView = 'EMPLOYEE_SERVICES_VIEW',
  EmployeeView = 'EMPLOYEE_VIEW',
  EmployeeViewBranch = 'EMPLOYEE_VIEW_BRANCH',
  EmployeeViewClient = 'EMPLOYEE_VIEW_CLIENT',
  EmployeeViewPosition = 'EMPLOYEE_VIEW_POSITION',
  EmployeeViewProduct = 'EMPLOYEE_VIEW_PRODUCT',
  EmployeeViewProductCategory = 'EMPLOYEE_VIEW_PRODUCT_CATEGORY',
  EmployeeViewSelf = 'EMPLOYEE_VIEW_SELF',
  EmployeeViewService = 'EMPLOYEE_VIEW_SERVICE',
  EmployeeViewServiceCategory = 'EMPLOYEE_VIEW_SERVICE_CATEGORY',
  EmployeeViewStorage = 'EMPLOYEE_VIEW_STORAGE',
  EmployeeViewTechnologicalMap = 'EMPLOYEE_VIEW_TECHNOLOGICAL_MAP',
  EmployeeViewTechnologicalMapCategory = 'EMPLOYEE_VIEW_TECHNOLOGICAL_MAP_CATEGORY',
  LogbookBookingCreate = 'LOGBOOK_BOOKING_CREATE',
  LogbookBookingEdit = 'LOGBOOK_BOOKING_EDIT',
  LogbookBookingStatusEdit = 'LOGBOOK_BOOKING_STATUS_EDIT',
  LogbookConsumablesWriteOff = 'LOGBOOK_CONSUMABLES_WRITE_OFF',
  LogbookHistoryView = 'LOGBOOK_HISTORY_VIEW',
  LogbookPopoverBookingStatusEdit = 'LOGBOOK_POPOVER_BOOKING_STATUS_EDIT',
  LogbookSettingsEdit = 'LOGBOOK_SETTINGS_EDIT',
  LogbookView = 'LOGBOOK_VIEW',
  MenuCloneEdit = 'MENU_CLONE_EDIT',
  MenuCreate = 'MENU_CREATE',
  MenuDeleteRestore = 'MENU_DELETE_RESTORE',
  MenuDishCategoryCreate = 'MENU_DISH_CATEGORY_CREATE',
  MenuDishCategoryDeleteRestore = 'MENU_DISH_CATEGORY_DELETE_RESTORE',
  MenuDishCategoryEdit = 'MENU_DISH_CATEGORY_EDIT',
  MenuDishCategoryExport = 'MENU_DISH_CATEGORY_EXPORT',
  MenuDishCategoryImport = 'MENU_DISH_CATEGORY_IMPORT',
  MenuDishCategoryListView = 'MENU_DISH_CATEGORY_LIST_VIEW',
  MenuDishClone = 'MENU_DISH_CLONE',
  MenuDishCreate = 'MENU_DISH_CREATE',
  MenuDishDeleteRestore = 'MENU_DISH_DELETE_RESTORE',
  MenuDishEdit = 'MENU_DISH_EDIT',
  MenuDishListView = 'MENU_DISH_LIST_VIEW',
  MenuListView = 'MENU_LIST_VIEW',
  MenuOptionsAndSupplementsCreate = 'MENU_OPTIONS_AND_SUPPLEMENTS_CREATE',
  MenuOptionsAndSupplementsDeleteRestore = 'MENU_OPTIONS_AND_SUPPLEMENTS_DELETE_RESTORE',
  MenuOptionsAndSupplementsEdit = 'MENU_OPTIONS_AND_SUPPLEMENTS_EDIT',
  MenuOptionsAndSupplementsListView = 'MENU_OPTIONS_AND_SUPPLEMENTS_LIST_VIEW',
  OnlineBookingSettingsEdit = 'ONLINE_BOOKING_SETTINGS_EDIT',
  OnlineBookingSettingsView = 'ONLINE_BOOKING_SETTINGS_VIEW',
  Payment = 'PAYMENT',
  PaymentsHistoryView = 'PAYMENTS_HISTORY_VIEW',
  PaymentCreate = 'PAYMENT_CREATE',
  PaymentDelete = 'PAYMENT_DELETE',
  PaymentEdit = 'PAYMENT_EDIT',
  PositionCreate = 'POSITION_CREATE',
  PositionDelete = 'POSITION_DELETE',
  PositionEdit = 'POSITION_EDIT',
  PositionListView = 'POSITION_LIST_VIEW',
  ProductCategoryCreate = 'PRODUCT_CATEGORY_CREATE',
  ProductCategoryDeleteRestore = 'PRODUCT_CATEGORY_DELETE_RESTORE',
  ProductCategoryEdit = 'PRODUCT_CATEGORY_EDIT',
  ProductCategoryExport = 'PRODUCT_CATEGORY_EXPORT',
  ProductCategoryImport = 'PRODUCT_CATEGORY_IMPORT',
  ProductCategoryListView = 'PRODUCT_CATEGORY_LIST_VIEW',
  ProductCreate = 'PRODUCT_CREATE',
  ProductDeleteRestore = 'PRODUCT_DELETE_RESTORE',
  ProductEdit = 'PRODUCT_EDIT',
  ProductExport = 'PRODUCT_EXPORT',
  ProductImport = 'PRODUCT_IMPORT',
  ProductListView = 'PRODUCT_LIST_VIEW',
  RestoreBranch = 'RESTORE_BRANCH',
  ReviewCreate = 'REVIEW_CREATE',
  ReviewDelete = 'REVIEW_DELETE',
  ReviewEdit = 'REVIEW_EDIT',
  ReviewListView = 'REVIEW_LIST_VIEW',
  RoleClone = 'ROLE_CLONE',
  RoleCreateClone = 'ROLE_CREATE_CLONE',
  RoleDelete = 'ROLE_DELETE',
  RoleEdit = 'ROLE_EDIT',
  SalarySettingsEdit = 'SALARY_SETTINGS_EDIT',
  SalarySettingsView = 'SALARY_SETTINGS_VIEW',
  SalaryView = 'SALARY_VIEW',
  ScheduleCalendarView = 'SCHEDULE_CALENDAR_VIEW',
  ScheduleCreate = 'SCHEDULE_CREATE',
  ScheduleDelete = 'SCHEDULE_DELETE',
  ScheduleEdit = 'SCHEDULE_EDIT',
  SelfCheckSchedule = 'SELF_CHECK_SCHEDULE',
  SelfEditSchedule = 'SELF_EDIT_SCHEDULE',
  ServiceAndOnlineBookingEdit = 'SERVICE_AND_ONLINE_BOOKING_EDIT',
  ServiceCategoryCreate = 'SERVICE_CATEGORY_CREATE',
  ServiceCategoryDeleteRestore = 'SERVICE_CATEGORY_DELETE_RESTORE',
  ServiceCategoryEdit = 'SERVICE_CATEGORY_EDIT',
  ServiceCategoryExport = 'SERVICE_CATEGORY_EXPORT',
  ServiceCategoryImport = 'SERVICE_CATEGORY_IMPORT',
  ServiceCategoryListView = 'SERVICE_CATEGORY_LIST_VIEW',
  ServiceCreate = 'SERVICE_CREATE',
  ServiceDeleteRestore = 'SERVICE_DELETE_RESTORE',
  ServiceEmployeesEdit = 'SERVICE_EMPLOYEES_EDIT',
  ServiceEmployeesView = 'SERVICE_EMPLOYEES_VIEW',
  ServiceExport = 'SERVICE_EXPORT',
  ServiceImport = 'SERVICE_IMPORT',
  ServiceListView = 'SERVICE_LIST_VIEW',
  ServiceTechMapsEdit = 'SERVICE_TECH_MAPS_EDIT',
  ServiceTechMapsView = 'SERVICE_TECH_MAPS_VIEW',
  StorageOperations = 'STORAGE_OPERATIONS',
  StorageReport = 'STORAGE_REPORT',
  TariffModulesManage = 'TARIFF_MODULES_MANAGE',
  TariffSubscriptionManage = 'TARIFF_SUBSCRIPTION_MANAGE',
  TariffView = 'TARIFF_VIEW',
  TechMapCategoryCreate = 'TECH_MAP_CATEGORY_CREATE',
  TechMapCategoryDeleteRestore = 'TECH_MAP_CATEGORY_DELETE_RESTORE',
  TechMapCategoryEdit = 'TECH_MAP_CATEGORY_EDIT',
  TechMapCategoryExport = 'TECH_MAP_CATEGORY_EXPORT',
  TechMapCategoryImport = 'TECH_MAP_CATEGORY_IMPORT',
  TechMapCategoryListView = 'TECH_MAP_CATEGORY_LIST_VIEW',
  TechMapCreate = 'TECH_MAP_CREATE',
  TechMapDeleteRestore = 'TECH_MAP_DELETE_RESTORE',
  TechMapEdit = 'TECH_MAP_EDIT',
  TechMapListView = 'TECH_MAP_LIST_VIEW',
  TechMapProductListEdit = 'TECH_MAP_PRODUCT_LIST_EDIT',
  TechMapProductListView = 'TECH_MAP_PRODUCT_LIST_VIEW',
  TechMapServiceListEdit = 'TECH_MAP_SERVICE_LIST_EDIT',
  TechMapServiceListView = 'TECH_MAP_SERVICE_LIST_VIEW',
  VacationCreate = 'VACATION_CREATE',
  VacationDelete = 'VACATION_DELETE',
  VacationEdit = 'VACATION_EDIT',
  ViewCompany = 'VIEW_COMPANY',
  ViewEmployee = 'VIEW_EMPLOYEE',
  WarehouseCreate = 'WAREHOUSE_CREATE',
  WarehouseDeleteRestore = 'WAREHOUSE_DELETE_RESTORE',
  WarehouseEdit = 'WAREHOUSE_EDIT',
  WarehouseListView = 'WAREHOUSE_LIST_VIEW',
  WarehouseOperationArrivalEdit = 'WAREHOUSE_OPERATION_ARRIVAL_EDIT',
  WarehouseOperationConsumablesWriteOffEdit = 'WAREHOUSE_OPERATION_CONSUMABLES_WRITE_OFF_EDIT',
  WarehouseOperationEditHistoryView = 'WAREHOUSE_OPERATION_EDIT_HISTORY_VIEW',
  WarehouseOperationListView = 'WAREHOUSE_OPERATION_LIST_VIEW',
  WarehouseOperationMoveEdit = 'WAREHOUSE_OPERATION_MOVE_EDIT',
  WarehouseOperationProductWriteOffEdit = 'WAREHOUSE_OPERATION_PRODUCT_WRITE_OFF_EDIT',
  WarehouseOperationSaleCreate = 'WAREHOUSE_OPERATION_SALE_CREATE',
  WarehouseOperationSaleEdit = 'WAREHOUSE_OPERATION_SALE_EDIT',
  WarehouseProductAdd = 'WAREHOUSE_PRODUCT_ADD',
  WarehouseProductArrival = 'WAREHOUSE_PRODUCT_ARRIVAL',
  WarehouseProductCreateAndAdd = 'WAREHOUSE_PRODUCT_CREATE_AND_ADD',
  WarehouseProductDelete = 'WAREHOUSE_PRODUCT_DELETE',
  WarehouseProductListView = 'WAREHOUSE_PRODUCT_LIST_VIEW',
  WarehouseProductMove = 'WAREHOUSE_PRODUCT_MOVE',
  WarehouseProductWriteOff = 'WAREHOUSE_PRODUCT_WRITE_OFF',
  WarehouseReportViewExport = 'WAREHOUSE_REPORT_VIEW_EXPORT'
}

export type CompanyAccessProxy = {
  __typename?: 'CompanyAccessProxy';
  action?: Maybe<CompanyAccess>;
  id: Scalars['Int']['output'];
  role?: Maybe<RoleProxy>;
  scope?: Maybe<PermissionScope>;
};

export type CompanyInput = {
  address: Scalars['String']['input'];
  category: CompanyTypeEnum;
  city?: InputMaybe<Scalars['Int']['input']>;
  country: Scalars['Int']['input'];
  currency: Scalars['Int']['input'];
  deleted: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  isUpdateLogo?: InputMaybe<Scalars['Boolean']['input']>;
  languages?: InputMaybe<Array<Scalars['Int']['input']>>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  messageLanguage: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  otherCity?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  primaryLanguage?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['Int']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  workSchedule?: InputMaybe<Scalars['String']['input']>;
  workSchedules?: InputMaybe<Array<BranchWorkScheduleInput>>;
};

export type CompanyLanguageInput = {
  languages?: InputMaybe<Array<Scalars['Int']['input']>>;
  primaryLanguage: Scalars['Int']['input'];
};

export type CompanyProxy = {
  __typename?: 'CompanyProxy';
  address: Scalars['String']['output'];
  bookingQrLink: Scalars['String']['output'];
  bookings?: Maybe<BookingPaginated>;
  branchTypes?: Maybe<Array<BranchTypeProxy>>;
  branches?: Maybe<Array<BranchProxy>>;
  branchesPaginated?: Maybe<BranchPaginated>;
  category?: Maybe<CompanyTypeProxy>;
  city?: Maybe<CityProxy>;
  clients?: Maybe<ClientPaginated>;
  country?: Maybe<CountryProxy>;
  currency?: Maybe<CurrencyProxy>;
  dateTimeFormat?: Maybe<DateTimeFormatProxy>;
  deleted: Scalars['Boolean']['output'];
  employeePositions?: Maybe<EmployeePositionPaginated>;
  employees?: Maybe<EmployeePaginated>;
  employeesList?: Maybe<Array<EmployeeProxy>>;
  employeesNotInBranch?: Maybe<Array<EmployeeProxy>>;
  expiredPaidFeatures?: Maybe<Array<PaidFeatureProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isPremiumOn: Scalars['Boolean']['output'];
  language?: Maybe<LanguageProxy>;
  languages?: Maybe<Array<LanguageProxy>>;
  loggedInUser?: Maybe<EmployeeProxy>;
  meBookingModuleConfig?: Maybe<BookingModuleConfigProxy>;
  meBookingSyncStatus?: Maybe<Scalars['Int']['output']>;
  meMenuCategories?: Maybe<Array<MenuCategoryProxy>>;
  meMenuCategoriesPaginated?: Maybe<MenuCategoryPaginated>;
  menuCategoryIconList?: Maybe<Array<MenuCategoryIconProxy>>;
  menuItems?: Maybe<MenuItemPaginated>;
  menuItemsList?: Maybe<Array<Maybe<MenuItemProxy>>>;
  menuSupplements?: Maybe<MenuSupplementPaginated>;
  menuSupplementsList?: Maybe<Array<MenuSupplementProxy>>;
  messageLanguage?: Maybe<LanguageProxy>;
  modules?: Maybe<Array<ModuleProxy>>;
  name: Scalars['String']['output'];
  ownerPosition?: Maybe<EmployeePositionProxy>;
  paidFeatures?: Maybe<Array<PaidFeatureProxy>>;
  paidFeaturesPaginated: PaidFeaturePaginated;
  paymentOrders?: Maybe<Array<PaymentOrderProxy>>;
  phone: Scalars['String']['output'];
  primaryLanguage?: Maybe<LanguageProxy>;
  productCategories?: Maybe<Array<ProductCategoryNewProxy>>;
  products?: Maybe<Array<ProductProxy>>;
  productsList?: Maybe<ProductPaginated>;
  reviews?: Maybe<ReviewPaginated>;
  salaryPayments?: Maybe<SalaryPaymentPaginated>;
  serviceCategoriesNew?: Maybe<Array<ServiceCategoryNewProxy>>;
  services?: Maybe<ServicePaginated>;
  servicesList?: Maybe<Array<ServiceProxy>>;
  servicesListForTechMap?: Maybe<ServicePaginated>;
  suppliers?: Maybe<Array<SupplierProxy>>;
  techMapListForServices?: Maybe<TechnologicalMapPaginated>;
  technologicalMapCategories?: Maybe<Array<TechnologicalMapCategoryProxy>>;
  technologicalMapCategoriesNew?: Maybe<Array<TechMapCategoryNewProxy>>;
  technologicalMaps?: Maybe<TechnologicalMapPaginated>;
  technologicalMapsList?: Maybe<Array<TechnologicalMapProxy>>;
  timeZone?: Maybe<TimeZoneProxy>;
  userCompanyRelations?: Maybe<Array<UserCompanyRelationProxy>>;
  website?: Maybe<Scalars['String']['output']>;
};


export type CompanyProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  salaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyBranchTypesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyBranchesPaginatedArgs = {
  branchTypeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyClientsArgs = {
  amountOfVisits?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyEmployeePositionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyEmployeesArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filterByNameAndPosition?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  positionId?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyEmployeesListArgs = {
  positionId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyEmployeesNotInBranchArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBranchId: Scalars['Int']['input'];
};


export type CompanyProxyLanguagesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyMeMenuCategoriesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  keepWithoutMenuRelation?: InputMaybe<Scalars['Boolean']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithItemRelations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyMeMenuCategoriesPaginatedArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyMenuItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyMenuItemsListArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  excludeForCategory?: InputMaybe<Scalars['Boolean']['input']>;
  excludedCategoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyMenuSupplementsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyMenuSupplementsListArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  menuCategoryId?: InputMaybe<Scalars['Int']['input']>;
  onlyParent?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyModulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isOnlyParents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyPaidFeaturesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyPaidFeaturesPaginatedArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyPaymentOrdersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyProductCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyProductsListArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyReviewsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  employeeEmail?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  reviewSortField?: InputMaybe<Scalars['String']['input']>;
  reviewType?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxySalaryPaymentsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyServiceCategoriesNewArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyServicesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyFromBookings?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  withoutArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyServicesListArgs = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyServicesListForTechMapArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  techMapId: Scalars['Int']['input'];
};


export type CompanyProxyTechMapListForServicesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['Int']['input'];
};


export type CompanyProxyTechnologicalMapCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyTechnologicalMapCategoriesNewArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyProxyTechnologicalMapsArgs = {
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  techMapId?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyProxyTechnologicalMapsListArgs = {
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyProxyUserCompanyRelationsArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyType = {
  __typename?: 'CompanyType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CompanyTypeEnum {
  FoodBusiness = 'FOOD_BUSINESS',
  OtherBusiness = 'OTHER_BUSINESS',
  ServiceBusiness = 'SERVICE_BUSINESS'
}

export type CompanyTypeProxy = {
  __typename?: 'CompanyTypeProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


export type CompanyTypeProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Country = {
  __typename?: 'Country';
  continentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isInEuropeanUnion: Scalars['Boolean']['output'];
  isoCode: Scalars['String']['output'];
  localeCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryGeoProxy = {
  __typename?: 'CountryGeoProxy';
  citiesPaginated?: Maybe<CityPaginated>;
  city?: Maybe<Array<Maybe<CityProxy>>>;
  country?: Maybe<CountryProxy>;
  timezone?: Maybe<Array<Maybe<TimeZoneProxy>>>;
};


export type CountryGeoProxyCitiesPaginatedArgs = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CountryProxy = {
  __typename?: 'CountryProxy';
  alpha3IsoCode?: Maybe<Scalars['String']['output']>;
  branches?: Maybe<Array<BranchProxy>>;
  cities?: Maybe<Array<CityProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  continentCode?: Maybe<Scalars['String']['output']>;
  continentName?: Maybe<Scalars['String']['output']>;
  currencies?: Maybe<Array<CurrencyProxy>>;
  europeanUnion: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isoCode?: Maybe<Scalars['String']['output']>;
  localeCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneCode?: Maybe<PhoneCodeProxy>;
  slug: Scalars['String']['output'];
  timezone?: Maybe<Array<Maybe<TimeZoneProxy>>>;
};


export type CountryProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryProxyCitiesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CountryProxyCurrenciesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateStorageProductRelationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  product?: InputMaybe<ProductInput>;
  quantity: Scalars['Int']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['Int']['input'];
};

export enum Currency {
  Eur = 'EUR',
  Uah = 'UAH',
  Usd = 'USD'
}

export type CurrencyProxy = {
  __typename?: 'CurrencyProxy';
  code?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<CompanyProxy>>;
  countries?: Maybe<Array<CountryProxy>>;
  currency?: Maybe<Scalars['String']['output']>;
  currencySign?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};


export type CurrencyProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CurrencyProxyCountriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomDayInput = {
  customDayPeriods: Array<CustomDayPeriodInput>;
  date: Scalars['Date']['input'];
};

export type CustomDayPeriodInput = {
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
};

export type CustomDayPeriodProxy = {
  __typename?: 'CustomDayPeriodProxy';
  customDay?: Maybe<CustomDayProxy>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
};


export type CustomDayPeriodProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type CustomDayPeriodProxyStartTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type CustomDayProxy = {
  __typename?: 'CustomDayProxy';
  branch?: Maybe<BranchProxy>;
  customDayPeriods?: Maybe<Array<CustomDayPeriodProxy>>;
  date?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
};


export type CustomDayProxyCustomDayPeriodsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomDayProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFormat = {
  __typename?: 'DateTimeFormat';
  format: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DateTimeFormatProxy = {
  __typename?: 'DateTimeFormatProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  format: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};


export type DateTimeFormatProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type DateTimeFormatProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum DateTimePeriodType {
  FiveMonths = 'FIVE_MONTHS',
  FourMonths = 'FOUR_MONTHS',
  NineMonths = 'NINE_MONTHS',
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  OneYear = 'ONE_YEAR',
  SixMonths = 'SIX_MONTHS',
  ThreeMonths = 'THREE_MONTHS',
  ThreeWeeks = 'THREE_WEEKS',
  TwoMonths = 'TWO_MONTHS',
  TwoWeeks = 'TWO_WEEKS',
  Unlimited = 'UNLIMITED'
}

export type DayProxy = {
  __typename?: 'DayProxy';
  branchWorkSchedules?: Maybe<Array<BranchWorkScheduleProxy>>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  workingDayPeriods?: Maybe<Array<WorkingDayPeriodProxy>>;
};


export type DayProxyBranchWorkSchedulesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type DayProxyWorkingDayPeriodsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum DefaultWeek {
  CurrentWeek = 'CURRENT_WEEK',
  LastViewedWeek = 'LAST_VIEWED_WEEK'
}

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  deleted: Array<Scalars['Int']['output']>;
  failed: Array<Scalars['Int']['output']>;
};

export type DismissEmployeeInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  endOfCooperation: Scalars['String']['input'];
  reason: Scalars['Int']['input'];
};

export type DismissalEmployeeProxy = {
  __typename?: 'DismissalEmployeeProxy';
  comment?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  employeeDismissalReason?: Maybe<EmployeeDismissalReasonProxy>;
  endDateCooperation?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};


export type DismissalEmployeeProxyEndDateCooperationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeBookingProxy = {
  __typename?: 'EmployeeBookingProxy';
  aboutMe?: Maybe<Scalars['String']['output']>;
  allowDefault: Scalars['Boolean']['output'];
  avgRating?: Maybe<Scalars['Float']['output']>;
  closestBookingDate?: Maybe<Scalars['String']['output']>;
  closestBookingDateTimes?: Maybe<Array<BookingTime>>;
  employeeServiceRelation?: Maybe<EmployeeServiceRelationProxy>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastReviews?: Maybe<Array<ReviewProxy>>;
  name: Scalars['String']['output'];
  patronymic?: Maybe<Scalars['String']['output']>;
  position?: Maybe<EmployeePositionProxy>;
  qualificationConfirmations?: Maybe<Array<QualificationConfirmationProxy>>;
  reviewCount: Scalars['Int']['output'];
  specialization?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatusProxy>;
  surname?: Maybe<Scalars['String']['output']>;
};


export type EmployeeBookingProxyClosestBookingDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeBookingProxyQualificationConfirmationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeDismissalReasonProxy = {
  __typename?: 'EmployeeDismissalReasonProxy';
  dismissalEmployees?: Maybe<Array<DismissalEmployeeProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EmployeeDismissalReasonProxyDismissalEmployeesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeInput = {
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['Int']['input'];
  contract?: InputMaybe<Scalars['Upload']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeePosition: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  isUpdateAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateConfirmations?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateContract?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateImage?: InputMaybe<Scalars['Boolean']['input']>;
  itn?: InputMaybe<Scalars['String']['input']>;
  manualBlocking: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  passportData?: InputMaybe<Scalars['String']['input']>;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  qualificationConfirmations?: InputMaybe<Array<Scalars['Upload']['input']>>;
  role: Scalars['Int']['input'];
  showSurnameInBooking?: InputMaybe<Scalars['Boolean']['input']>;
  specialization: Scalars['String']['input'];
  status: Scalars['Int']['input'];
  surname: Scalars['String']['input'];
  tariffBlocking: Scalars['Boolean']['input'];
};

export type EmployeeLogin = {
  __typename?: 'EmployeeLogin';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  surname: Scalars['String']['output'];
};

export type EmployeePaginated = {
  __typename?: 'EmployeePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  employees?: Maybe<Array<EmployeeProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeePositionPaginated = {
  __typename?: 'EmployeePositionPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  employeePositions?: Maybe<Array<EmployeePositionProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeePositionProxy = {
  __typename?: 'EmployeePositionProxy';
  company?: Maybe<CompanyProxy>;
  description?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<EmployeeProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type EmployeePositionProxyEmployeesArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeProxy = {
  __typename?: 'EmployeeProxy';
  ServiceCategorySalaries?: Maybe<Array<ServiceCategorySalaryProxy>>;
  aboutMe?: Maybe<Scalars['String']['output']>;
  bookings?: Maybe<BookingPaginated>;
  company?: Maybe<CompanyProxy>;
  contract?: Maybe<Scalars['String']['output']>;
  customDays?: Maybe<Array<CustomDayProxy>>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dismissalEmployee?: Maybe<DismissalEmployeeProxy>;
  email: Scalars['String']['output'];
  employeeServiceRelations?: Maybe<Array<EmployeeServiceRelationProxy>>;
  employeeServices?: Maybe<EmployeeServicesPaginated>;
  employeeServicesList?: Maybe<Array<ServiceProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAnyBookingsPerDateRange: Scalars['Boolean']['output'];
  isAnySchedulePerDate: Scalars['Boolean']['output'];
  isAnySchedulePerDateRange: Scalars['Boolean']['output'];
  isAnyServiceRelation: Scalars['Boolean']['output'];
  isScheduleActive: Scalars['Boolean']['output'];
  itn?: Maybe<Scalars['String']['output']>;
  manualBlocking: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  originalContractName?: Maybe<Scalars['String']['output']>;
  passportData?: Maybe<Scalars['String']['output']>;
  patronymic?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  position?: Maybe<EmployeePositionProxy>;
  qualificationConfirmations?: Maybe<Array<QualificationConfirmationProxy>>;
  recordSetting?: Maybe<RecordSettingProxy>;
  relatedBranches?: Maybe<Array<BranchProxy>>;
  reviews?: Maybe<Array<ReviewProxy>>;
  role?: Maybe<RoleProxy>;
  salaryPayments?: Maybe<SalaryPaymentPaginated>;
  specialization?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmployeeStatusProxy>;
  surname?: Maybe<Scalars['String']['output']>;
  tariffBlocking: Scalars['Boolean']['output'];
  user?: Maybe<UserProxy>;
  userBranchRelations?: Maybe<Array<UserBranchRelationProxy>>;
  vacations?: Maybe<Array<VacationProxy>>;
  workSchedules?: Maybe<Array<WorkScheduleProxy>>;
};


export type EmployeeProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  excludeCustomDays?: InputMaybe<Scalars['Boolean']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  salaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyCustomDaysArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyDateOfBirthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyEmployeeServiceRelationsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyEmployeeServicesArgs = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  filterByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyEmployeeServicesListArgs = {
  accessibility?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  filterByEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  serviceName?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyIsAnyBookingsPerDateRangeArgs = {
  branchId: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type EmployeeProxyIsAnySchedulePerDateArgs = {
  date: Scalars['String']['input'];
};


export type EmployeeProxyIsAnySchedulePerDateRangeArgs = {
  date: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
};


export type EmployeeProxyQualificationConfirmationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyReviewsArgs = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxySalaryPaymentsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeProxyUserBranchRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyVacationsArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeProxyWorkSchedulesArgs = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeRecordSettingsInput = {
  isDefaultEmployee: Scalars['Boolean']['input'];
  isOnlineSignUpAvailable: Scalars['Boolean']['input'];
  isReviewsAvailable: Scalars['Boolean']['input'];
};

export type EmployeeServiceRelationInput = {
  duration: Scalars['String']['input'];
  onlineBooking: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  salaryType?: InputMaybe<SalaryType>;
  salaryValue?: InputMaybe<Scalars['Float']['input']>;
};

export type EmployeeServiceRelationInputAll = {
  employee?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeServiceRelationProxy = {
  __typename?: 'EmployeeServiceRelationProxy';
  deleted: Scalars['Boolean']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  online: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  salaryType?: Maybe<Scalars['Int']['output']>;
  salaryValue?: Maybe<Scalars['Float']['output']>;
  service?: Maybe<ServiceProxy>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type EmployeeServiceRelationProxyDurationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeServiceRelationProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeServicesPaginated = {
  __typename?: 'EmployeeServicesPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  employeeServices?: Maybe<Array<ServiceProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeSpecializationProxy = {
  __typename?: 'EmployeeSpecializationProxy';
  name: Scalars['String']['output'];
};

export type EmployeeStatusProxy = {
  __typename?: 'EmployeeStatusProxy';
  constId?: Maybe<Scalars['String']['output']>;
  employees?: Maybe<Array<EmployeeProxy>>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type EmployeeStatusProxyEmployeesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeWorkScheduleSetting = {
  __typename?: 'EmployeeWorkScheduleSetting';
  branch: Branch;
  defaultWeek?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmployeeWorkScheduleSettingInput = {
  branchId: Scalars['Int']['input'];
  defaultWeek?: InputMaybe<DefaultWeek>;
};

export type ExportJobProxy = {
  __typename?: 'ExportJobProxy';
  company: CompanyProxy;
  createdAt?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobType: JobType;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type ExportJobProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type GenderProxy = {
  __typename?: 'GenderProxy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GeneratePaymentUrlInput = {
  currency: Currency;
  plan: Scalars['Int']['input'];
};

export type ImportJobProxy = {
  __typename?: 'ImportJobProxy';
  company: CompanyProxy;
  createdAt?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobType: JobType;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  validationFilename?: Maybe<Scalars['String']['output']>;
};


export type ImportJobProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type JobContainerProxy = {
  __typename?: 'JobContainerProxy';
  exportJobs?: Maybe<Array<ExportJobProxy>>;
  importJobs?: Maybe<Array<ImportJobProxy>>;
  storageReportJobs?: Maybe<Array<StorageReportJobProxy>>;
};


export type JobContainerProxyExportJobsArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type JobContainerProxyImportJobsArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  validationFilename?: InputMaybe<Scalars['String']['input']>;
};


export type JobContainerProxyStorageReportJobsArgs = {
  branchId: Scalars['Int']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobEntity {
  /** All entity jobs */
  All = 'ALL',
  /** Client entity jobs */
  Client = 'CLIENT',
  /** Employee entity jobs */
  Employee = 'EMPLOYEE',
  /** Report entity jobs */
  Report = 'REPORT',
  /** Service entity jobs */
  Service = 'SERVICE',
  /** Service-category entity jobs */
  ServiceCategory = 'SERVICE_CATEGORY'
}

export enum JobStatus {
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS',
  ValidationFail = 'VALIDATION_FAIL'
}

export enum JobType {
  Export = 'EXPORT',
  Import = 'IMPORT',
  Report = 'REPORT'
}

export type Language = {
  __typename?: 'Language';
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LanguageProxy = {
  __typename?: 'LanguageProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  companiesByMessageLanguage?: Maybe<Array<CompanyProxy>>;
  companiesByPrimaryLanguage?: Maybe<Array<CompanyProxy>>;
  id: Scalars['Int']['output'];
  isMessage: Scalars['Boolean']['output'];
  isoCode: Scalars['String']['output'];
  menus?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
};


export type LanguageProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyCompaniesByMessageLanguageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyCompaniesByPrimaryLanguageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type LanguageProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum LogbookDefaultDay {
  CurrentDay = 'CURRENT_DAY',
  LastViewedDay = 'LAST_VIEWED_DAY'
}

export enum LogbookDefaultView {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum LogbookPastCreateStatus {
  Completed = 'COMPLETED',
  Manually = 'MANUALLY'
}

export type LogbookSetting = {
  __typename?: 'LogbookSetting';
  branch: Branch;
  defaultDay?: Maybe<Scalars['String']['output']>;
  defaultView?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isQuickBooking?: Maybe<Scalars['Boolean']['output']>;
  pastCreateStatus?: Maybe<Scalars['String']['output']>;
  useClientData?: Maybe<Scalars['Boolean']['output']>;
};

export type LogbookSettingInput = {
  branchId: Scalars['Int']['input'];
  defaultDay?: InputMaybe<LogbookDefaultDay>;
  defaultView?: InputMaybe<LogbookDefaultView>;
  isQuickBooking?: InputMaybe<Scalars['Boolean']['input']>;
  pastCreateStatus?: InputMaybe<LogbookPastCreateStatus>;
  useClientData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginCompany = {
  __typename?: 'LoginCompany';
  employee?: Maybe<EmployeeLogin>;
  id: Scalars['ID']['output'];
  isBlocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Me = {
  __typename?: 'Me';
  roles: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type MeBookingBranchConfigProxy = {
  __typename?: 'MeBookingBranchConfigProxy';
  branch?: Maybe<BranchProxy>;
  jsConfig?: Maybe<Scalars['String']['output']>;
};

export type MenuAllergenProxy = {
  __typename?: 'MenuAllergenProxy';
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<MenuItemProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuAllergenProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuCategoryIconProxy = {
  __typename?: 'MenuCategoryIconProxy';
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  path?: Maybe<Scalars['String']['output']>;
};

export type MenuCategoryInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  faviconId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuCategoryPaginated = {
  __typename?: 'MenuCategoryPaginated';
  categories?: Maybe<Array<MenuCategoryProxy>>;
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuCategoryProxy = {
  __typename?: 'MenuCategoryProxy';
  childCategories?: Maybe<Array<MenuCategoryProxy>>;
  comment?: Maybe<Scalars['String']['output']>;
  company: CompanyProxy;
  deleted: Scalars['Boolean']['output'];
  descriptionOrigin?: Maybe<Scalars['String']['output']>;
  descriptionTranslations?: Maybe<Array<TranslationProxy>>;
  favicon?: Maybe<MenuCategoryIconProxy>;
  id: Scalars['Int']['output'];
  isExistsInMenu: Scalars['Boolean']['output'];
  menuItems?: Maybe<Array<MenuItemProxy>>;
  menuItemsMerged?: Maybe<Array<MenuItemProxy>>;
  menuItemsNotInCategory?: Maybe<Array<MenuItemProxy>>;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  numberOfItems: Scalars['Int']['output'];
  parentCategory?: Maybe<MenuCategoryProxy>;
};


export type MenuCategoryProxyChildCategoriesArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  excludeChildren?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuCategoryProxyCommentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryProxyIsExistsInMenuArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuCategoryProxyMenuItemsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['Int']['input']>;
  needDirectlyFromCategory?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryProxyMenuItemsMergedArgs = {
  menuId: Scalars['Int']['input'];
};


export type MenuCategoryProxyMenuItemsNotInCategoryArgs = {
  menuId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  searchCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuCategoryProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuCategoryProxyNumberOfItemsArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuCategoryRelationInput = {
  category: Scalars['Int']['input'];
  items?: InputMaybe<Array<Scalars['Int']['input']>>;
  subcategoryRelations?: InputMaybe<Array<MenuCategoryRelationInput>>;
};

export type MenuCategoryRelationProxy = {
  __typename?: 'MenuCategoryRelationProxy';
  category: MenuCategoryProxy;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  itemRelations?: Maybe<Array<MenuItemRelationProxy>>;
  menu: MenuProxy;
  subcategoryRelations?: Maybe<Array<MenuCategoryRelationProxy>>;
};

export type MenuCategoryRelationSingleInput = {
  category: Scalars['Int']['input'];
  childIndex?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuInput = {
  languages: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  status: MenuStatusType;
  type: MenuTypeType;
};

export type MenuItemCategoryRelationInput = {
  category: Scalars['Int']['input'];
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  destinationCategory?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  menuItem?: InputMaybe<Scalars['Int']['input']>;
  menuItems?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MenuItemCloneInput = {
  category: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type MenuItemInput = {
  allergens?: InputMaybe<Array<Scalars['Int']['input']>>;
  categories: Array<Scalars['Int']['input']>;
  composition?: InputMaybe<Scalars['String']['input']>;
  cookingTime?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isLongCookingTime?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdateImage?: InputMaybe<Scalars['Boolean']['input']>;
  markers?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  portions: Array<MenuItemPortionInput>;
  supplements?: InputMaybe<Array<Scalars['Int']['input']>>;
  types: Array<MenuTypeType>;
  unit: Scalars['Int']['input'];
};

export type MenuItemPaginated = {
  __typename?: 'MenuItemPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<MenuItemProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuItemPortionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  volume: Scalars['Float']['input'];
};

export type MenuItemPortionProxy = {
  __typename?: 'MenuItemPortionProxy';
  id: Scalars['Int']['output'];
  item: MenuItemProxy;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  price: Scalars['Float']['output'];
  volume: Scalars['Float']['output'];
};


export type MenuItemPortionProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type MenuItemProxy = {
  __typename?: 'MenuItemProxy';
  allergens?: Maybe<Array<MenuAllergenProxy>>;
  availableDeliveryMenus?: Maybe<Array<MenuProxy>>;
  availableDineInMenus?: Maybe<Array<MenuProxy>>;
  availablePickupMenus?: Maybe<Array<MenuProxy>>;
  categories?: Maybe<Array<MenuCategoryProxy>>;
  company: CompanyProxy;
  composition?: Maybe<Scalars['String']['output']>;
  compositionOrigin?: Maybe<Scalars['String']['output']>;
  compositionTranslations?: Maybe<Array<TranslationProxy>>;
  cookingTime?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionOrigin?: Maybe<Scalars['String']['output']>;
  descriptionTranslations?: Maybe<Array<TranslationProxy>>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAvailableForCurrentMenu: Scalars['Boolean']['output'];
  isLongCookingTime: Scalars['Boolean']['output'];
  markers?: Maybe<Array<MenuMarkerProxy>>;
  menus?: Maybe<Array<MenuProxy>>;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  portions?: Maybe<Array<MenuItemPortionProxy>>;
  supplements?: Maybe<Array<MenuSupplementProxy>>;
  types?: Maybe<Array<MenuTypeProxy>>;
  unit: UnitProxy;
};


export type MenuItemProxyAllergensArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxyCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxyCompositionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyIsAvailableForCurrentMenuArgs = {
  menuId: Scalars['Int']['input'];
};


export type MenuItemProxyMarkersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyPortionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuItemProxySupplementsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MenuItemProxyTypesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemRelationProxy = {
  __typename?: 'MenuItemRelationProxy';
  categoryRelation: MenuCategoryRelationProxy;
  id: Scalars['Int']['output'];
  index: Scalars['Int']['output'];
  item: MenuItemProxy;
};

export type MenuMarkerProxy = {
  __typename?: 'MenuMarkerProxy';
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  items?: Maybe<Array<MenuItemProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuMarkerProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuPaginated = {
  __typename?: 'MenuPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  menus?: Maybe<Array<MenuProxy>>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuProxy = {
  __typename?: 'MenuProxy';
  branch: BranchProxy;
  categories?: Maybe<Array<MenuCategoryProxy>>;
  categoriesNotInMenu?: Maybe<Array<MenuCategoryProxy>>;
  categoryRelations?: Maybe<Array<MenuCategoryRelationProxy>>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAnyItems: Scalars['Boolean']['output'];
  isToFill: Scalars['Boolean']['output'];
  itemRelations?: Maybe<Array<MenuItemRelationProxy>>;
  items?: Maybe<Array<MenuItemProxy>>;
  languages?: Maybe<Array<LanguageProxy>>;
  name: Scalars['String']['output'];
  numberOfCategories: Scalars['Int']['output'];
  numberOfItems: Scalars['Int']['output'];
  primaryLanguage?: Maybe<LanguageProxy>;
  qrMenuLink: Scalars['String']['output'];
  qrMenuQrCode: Scalars['String']['output'];
  status: MenuStatusProxy;
  type: MenuTypeProxy;
};


export type MenuProxyCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuProxyCategoriesNotInMenuArgs = {
  onlyTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuProxyItemRelationsArgs = {
  categoryRelationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuProxyItemsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type MenuProxyLanguagesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuProxyQrMenuLinkArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuProxyQrMenuQrCodeArgs = {
  menuId?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuRelationsInput = {
  categoryRelations: Array<MenuCategoryRelationInput>;
};

export type MenuStatusProxy = {
  __typename?: 'MenuStatusProxy';
  id: Scalars['Int']['output'];
  menus?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuStatusProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum MenuStatusType {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  UnderDevelopment = 'UNDER_DEVELOPMENT'
}

export type MenuSupplementInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  groupName: Scalars['String']['input'];
  isRequireOnOrder: Scalars['Boolean']['input'];
  items?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxCountOnOrder: Scalars['Int']['input'];
  options: Array<MenuSupplementOptionInput>;
};

export type MenuSupplementOptionInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type MenuSupplementPaginated = {
  __typename?: 'MenuSupplementPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  supplements?: Maybe<Array<MenuSupplementProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MenuSupplementProxy = {
  __typename?: 'MenuSupplementProxy';
  company: CompanyProxy;
  deleted: Scalars['Boolean']['output'];
  dependentSupplements?: Maybe<Array<MenuSupplementProxy>>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupNameOrigin?: Maybe<Scalars['String']['output']>;
  groupNameTranslations?: Maybe<Array<TranslationProxy>>;
  id: Scalars['Int']['output'];
  isRequireOnOrder?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<MenuItemProxy>>;
  maxCountOnOrder?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameOrigin?: Maybe<Scalars['String']['output']>;
  nameTranslations?: Maybe<Array<TranslationProxy>>;
  numberOfOption?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<MenuSupplementProxy>>;
  parent?: Maybe<MenuSupplementProxy>;
  price?: Maybe<Scalars['Float']['output']>;
};


export type MenuSupplementProxyDependentSupplementsArgs = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MenuSupplementProxyGroupNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSupplementProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuSupplementProxyNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MenuSupplementProxyOptionsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuTypeProxy = {
  __typename?: 'MenuTypeProxy';
  id: Scalars['Int']['output'];
  items?: Maybe<Array<MenuItemProxy>>;
  menus?: Maybe<Array<MenuProxy>>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type MenuTypeProxyItemsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MenuTypeProxyMenusArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum MenuTypeType {
  Delivery = 'DELIVERY',
  DineIn = 'DINE_IN',
  Pickup = 'PICKUP'
}

export type ModuleInputType = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModuleProxy = {
  __typename?: 'ModuleProxy';
  active: Scalars['Boolean']['output'];
  childModules?: Maybe<Array<Maybe<ModuleProxy>>>;
  companies?: Maybe<Array<CompanyProxy>>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isFreeAccess: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPaymentRequired: Scalars['Boolean']['output'];
  monthlyTariffPlan?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentModule?: Maybe<ModuleProxy>;
  yearlyTariffPlan?: Maybe<Scalars['String']['output']>;
};


export type ModuleProxyActiveArgs = {
  companyId: Scalars['Int']['input'];
};


export type ModuleProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ModuleProxyIsPaidArgs = {
  companyId: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addProductTechMap: TechnologicalMapProductRelationProxy;
  changePassword: Scalars['Boolean']['output'];
  /** @deprecated This mutation is deprecated, please use manageMenuCategoryRelation and manageMenuItemCategoryRelation. */
  checkMenuRelations: MenuProxy;
  cloneMenu: MenuProxy;
  /** @deprecated This mutation is deprecated, please use cloneMenuItemNew. */
  cloneMenuItem: MenuItemProxy;
  cloneMenuItemNew: MenuItemProxy;
  createAllRelations?: Maybe<Array<EmployeeServiceRelationProxy>>;
  createBranch: BranchProxy;
  createClient: ClientProxy;
  createCompany: CompanyProxy;
  createCustomDay: CustomDayProxy;
  createCustomRole: RoleProxy;
  createEmployee: EmployeeProxy;
  createEmployeePosition: EmployeePositionProxy;
  createEmployeeServiceRelation: EmployeeServiceRelationProxy;
  createMenu: MenuProxy;
  createMenuCategory: MenuCategoryProxy;
  createMenuItem: MenuItemProxy;
  createMenuSupplement: MenuSupplementProxy;
  createOwner: EmployeeProxy;
  createProduct: ProductProxy;
  createProductCategoryNew: ProductCategoryNewProxy;
  createReview: ReviewProxy;
  createSalaryPayment: SalaryPaymentProxy;
  createService: ServiceProxy;
  createServiceCategoryNew: ServiceCategoryNewProxy;
  createServiceCategorySalary: ServiceCategorySalaryProxy;
  createStorage: StorageProxy;
  createStorageProductRelation: StorageProductRelationProxy;
  createTechMapCategory: TechMapCategoryNewProxy;
  createTechnologicalMap: TechnologicalMapProxy;
  createUserBranchRelation: Array<UserBranchRelationProxy>;
  createVacation: VacationProxy;
  createWorkSchedule: WorkScheduleProxy;
  deleteAllRelations: Scalars['Boolean']['output'];
  deleteBranch: Scalars['Boolean']['output'];
  deleteClient: Scalars['Boolean']['output'];
  deleteDismissEmployee: Scalars['Boolean']['output'];
  deleteEmployeePosition: Scalars['Boolean']['output'];
  deleteEmployeeServiceRelation: Scalars['Boolean']['output'];
  deleteMenu: Scalars['Boolean']['output'];
  deleteMenuCategory: Scalars['Boolean']['output'];
  deleteMenuItem: Scalars['Boolean']['output'];
  deleteMenuSupplement: Scalars['Boolean']['output'];
  deleteOrRestoreCustomRole: RoleProxy;
  deleteProductCategory: ProductCategoryNewProxy;
  deleteProducts: DeleteResponse;
  deleteReview: Scalars['Boolean']['output'];
  deleteSalaryPayment: Scalars['Boolean']['output'];
  deleteService: ServiceProxy;
  deleteServiceCategoryNew: ServiceCategoryNewProxy;
  deleteStorage: StorageProxy;
  deleteStorageProductRelation: Scalars['Boolean']['output'];
  deleteTechMapCategory: TechMapCategoryNewProxy;
  deleteTechMaps: DeleteResponse;
  deleteUserBranchRelation: Scalars['Boolean']['output'];
  deleteVacation: Scalars['Boolean']['output'];
  deleteWorkSchedule: Scalars['Boolean']['output'];
  dismissEmployee: DismissalEmployeeProxy;
  editProductTechMap: TechnologicalMapProductRelationProxy;
  generateManageUrl: Scalars['String']['output'];
  generatePaymentUrl: Scalars['String']['output'];
  manageMenuCategoryRelation: MenuProxy;
  manageMenuItemCategoryRelation: MenuProxy;
  removeProductsFromTechMap: Scalars['Boolean']['output'];
  resendRegistrationMail: Scalars['Boolean']['output'];
  restoreBranch: BranchProxy;
  restoreMenu: Scalars['Boolean']['output'];
  restoreMenuCategory: Scalars['Boolean']['output'];
  restoreMenuItem: Scalars['Boolean']['output'];
  restoreMenuSupplement: Scalars['Boolean']['output'];
  restoreProduct: ProductProxy;
  restoreProductCategory: ProductCategoryNewProxy;
  restoreService: ServiceProxy;
  restoreServiceCategoryNew: ServiceCategoryNewProxy;
  restoreStorage: StorageProxy;
  restoreTechMapCategory: TechMapCategoryNewProxy;
  restoreTechnologicalMap: TechnologicalMapProxy;
  saleProducts?: Maybe<Array<StorageProductRelationProxy>>;
  updateBookingBranchConfig: Scalars['Boolean']['output'];
  updateBranch: BranchProxy;
  updateBranchOnlineBookingSettings: Scalars['Boolean']['output'];
  updateClient: ClientProxy;
  updateCompany: CompanyProxy;
  updateCompanyLanguages: CompanyProxy;
  updateCompanyModuleRelation: CompanyProxy;
  updateCompanyModulesRelation: CompanyProxy;
  updateCompanyOnlineBookingSettings: Scalars['Boolean']['output'];
  updateCurrentBranch: Scalars['Boolean']['output'];
  updateCustomDay?: Maybe<CustomDayProxy>;
  updateCustomRole: RoleProxy;
  updateDismissEmployee: DismissalEmployeeProxy;
  updateEmployee: EmployeeProxy;
  updateEmployeePosition: EmployeePositionProxy;
  updateEmployeeRecordSettings: RecordSettingProxy;
  updateEmployeeServiceRelation: EmployeeServiceRelationProxy;
  updateEmployeeServiceRelationsFromService: Scalars['Boolean']['output'];
  updateEmployeeWorkScheduleSettings: EmployeeWorkScheduleSetting;
  updateLogbookSettings: LogbookSetting;
  updateMenu: MenuProxy;
  updateMenuCategory: MenuCategoryProxy;
  updateMenuItem: MenuItemProxy;
  updateMenuStatus: MenuProxy;
  updateMenuSupplement: MenuSupplementProxy;
  updateOnlineBookingCompanyAllBranches: Scalars['Boolean']['output'];
  updateProduct: ProductProxy;
  updateProductCategory: ProductCategoryNewProxy;
  updateReview: ReviewProxy;
  updateSalaryPayment: SalaryPaymentProxy;
  updateSaleProducts: Scalars['Boolean']['output'];
  updateService: ServiceProxy;
  updateServiceCategoryNew: ServiceCategoryNewProxy;
  updateServiceCategorySalary: ServiceCategorySalaryProxy;
  updateServiceConnection: Scalars['Boolean']['output'];
  updateStorage: StorageProxy;
  updateStorageProductHistory?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  updateStorageProductRelation: StorageProductRelationProxy;
  updateTechMapCategory: TechMapCategoryNewProxy;
  updateTechMapConnection: Scalars['Boolean']['output'];
  updateTechnologicalMap: TechnologicalMapProxy;
  updateUser: UserProxy;
  updateVacation: VacationProxy;
  updateWorkSchedule: WorkScheduleProxy;
  updateWriteOffProducts: Scalars['Boolean']['output'];
  writeOffProducts: Scalars['Boolean']['output'];
};


export type MutationAddProductTechMapArgs = {
  branchId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  techMapId: Scalars['Int']['input'];
};


export type MutationChangePasswordArgs = {
  companyId: Scalars['Int']['input'];
  input: ChangePasswordInput;
};


export type MutationCheckMenuRelationsArgs = {
  companyId: Scalars['Int']['input'];
  input: MenuRelationsInput;
  menuId: Scalars['Int']['input'];
};


export type MutationCloneMenuArgs = {
  branchId: Scalars['Int']['input'];
  cloneMenuId: Scalars['Int']['input'];
  input: MenuInput;
};


export type MutationCloneMenuItemArgs = {
  branchId: Scalars['Int']['input'];
  cloneMenuItemId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuItemInput;
};


export type MutationCloneMenuItemNewArgs = {
  branchId: Scalars['Int']['input'];
  cloneMenuItemId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuItemCloneInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAllRelationsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: EmployeeServiceRelationInputAll;
};


export type MutationCreateBranchArgs = {
  companyId: Scalars['Int']['input'];
  input: BranchInput;
};


export type MutationCreateClientArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: ClientInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationCreateCustomDayArgs = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: CustomDayInput;
};


export type MutationCreateCustomRoleArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: RoleInput;
};


export type MutationCreateEmployeeArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: EmployeeInput;
};


export type MutationCreateEmployeePositionArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: PositionInput;
};


export type MutationCreateEmployeeServiceRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: EmployeeServiceRelationInput;
  serviceId: Scalars['Int']['input'];
};


export type MutationCreateMenuArgs = {
  branchId: Scalars['Int']['input'];
  input: MenuInput;
};


export type MutationCreateMenuCategoryArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuCategoryInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMenuItemArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuItemInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMenuSupplementArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuSupplementInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOwnerArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: EmployeeInput;
};


export type MutationCreateProductArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: ProductInput;
};


export type MutationCreateProductCategoryNewArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: ProductCategoryNewInput;
};


export type MutationCreateReviewArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: ReviewAdminInput;
};


export type MutationCreateSalaryPaymentArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: SalaryPaymentInput;
};


export type MutationCreateServiceArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: ServiceInput;
};


export type MutationCreateServiceCategoryNewArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: ServiceCategoryNewInput;
};


export type MutationCreateServiceCategorySalaryArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: ServiceCategorySalaryInput;
};


export type MutationCreateStorageArgs = {
  branchId: Scalars['Int']['input'];
  input: StorageInput;
};


export type MutationCreateStorageProductRelationArgs = {
  branchId: Scalars['Int']['input'];
  input: CreateStorageProductRelationInput;
  productId?: InputMaybe<Scalars['Int']['input']>;
  storageId: Scalars['Int']['input'];
};


export type MutationCreateTechMapCategoryArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: TechMapCategoryNewInput;
};


export type MutationCreateTechnologicalMapArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: TechnologicalMapInput;
};


export type MutationCreateUserBranchRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: Array<UserBranchRelationInput>;
};


export type MutationCreateVacationArgs = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: VacationInput;
};


export type MutationCreateWorkScheduleArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: WorkScheduleInput;
};


export type MutationDeleteAllRelationsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: EmployeeServiceRelationInputAll;
};


export type MutationDeleteBranchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteClientArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteDismissEmployeeArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteEmployeePositionArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  newPositionId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteEmployeeServiceRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteMenuArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteMenuCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteMenuItemArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteMenuSupplementArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteOrRestoreCustomRoleArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  deleted: Scalars['Boolean']['input'];
  roleId: Scalars['Int']['input'];
};


export type MutationDeleteProductCategoryArgs = {
  branchId: Scalars['Int']['input'];
  productCategoryId: Scalars['Int']['input'];
};


export type MutationDeleteProductsArgs = {
  branchId: Scalars['Int']['input'];
  productIds: Array<Scalars['Int']['input']>;
};


export type MutationDeleteReviewArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteSalaryPaymentArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  salaryPaymentId: Scalars['Int']['input'];
};


export type MutationDeleteServiceArgs = {
  branchId: Scalars['Int']['input'];
  serviceId: Scalars['Int']['input'];
};


export type MutationDeleteServiceCategoryNewArgs = {
  branchId: Scalars['Int']['input'];
  serviceCategoryId: Scalars['Int']['input'];
};


export type MutationDeleteStorageArgs = {
  branchId: Scalars['Int']['input'];
  storageId: Scalars['Int']['input'];
};


export type MutationDeleteStorageProductRelationArgs = {
  branchId: Scalars['Int']['input'];
  storageProductRelationId: Scalars['Int']['input'];
};


export type MutationDeleteTechMapCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationDeleteTechMapsArgs = {
  branchId: Scalars['Int']['input'];
  techMapIds: Array<Scalars['Int']['input']>;
};


export type MutationDeleteUserBranchRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteVacationArgs = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  vacationId: Scalars['Int']['input'];
};


export type MutationDeleteWorkScheduleArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  finishByToday?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationDismissEmployeeArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: DismissEmployeeInput;
};


export type MutationEditProductTechMapArgs = {
  branchId: Scalars['Int']['input'];
  input: TechMapProductInput;
  relationId: Scalars['Int']['input'];
};


export type MutationGenerateManageUrlArgs = {
  branchId: Scalars['Int']['input'];
  paidFeatureId: Scalars['Int']['input'];
};


export type MutationGeneratePaymentUrlArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: GeneratePaymentUrlInput;
};


export type MutationManageMenuCategoryRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuCategoryRelationSingleInput;
  menuId: Scalars['Int']['input'];
};


export type MutationManageMenuItemCategoryRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: MenuItemCategoryRelationInput;
  menuId: Scalars['Int']['input'];
};


export type MutationRemoveProductsFromTechMapArgs = {
  branchId: Scalars['Int']['input'];
  relationIds: Array<Scalars['Int']['input']>;
};


export type MutationResendRegistrationMailArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
};


export type MutationRestoreBranchArgs = {
  id: Scalars['Int']['input'];
  input: BranchInput;
};


export type MutationRestoreMenuArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRestoreMenuCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRestoreMenuItemArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRestoreMenuSupplementArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRestoreProductArgs = {
  branchId: Scalars['Int']['input'];
  input: ProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationRestoreProductCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ProductCategoryNewInput;
};


export type MutationRestoreServiceArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ServiceInput;
};


export type MutationRestoreServiceCategoryNewArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ServiceCategoryNewInput;
};


export type MutationRestoreStorageArgs = {
  branchId: Scalars['Int']['input'];
  input: StorageInput;
  storageId: Scalars['Int']['input'];
};


export type MutationRestoreTechMapCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: TechMapCategoryNewInput;
};


export type MutationRestoreTechnologicalMapArgs = {
  branchId: Scalars['Int']['input'];
  input: TechnologicalMapInput;
  technologicalMapId: Scalars['Int']['input'];
};


export type MutationSaleProductsArgs = {
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input?: InputMaybe<Array<StorageOperationInput>>;
};


export type MutationUpdateBookingBranchConfigArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  configs: BranchMultipleConfigUpdateInput;
};


export type MutationUpdateBranchArgs = {
  id: Scalars['Int']['input'];
  input: BranchInput;
};


export type MutationUpdateBranchOnlineBookingSettingsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: OnlineBookingSettings;
};


export type MutationUpdateClientArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ClientInput;
};


export type MutationUpdateCompanyArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: CompanyInput;
};


export type MutationUpdateCompanyLanguagesArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: CompanyLanguageInput;
};


export type MutationUpdateCompanyModuleRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: ModuleInputType;
};


export type MutationUpdateCompanyModulesRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: Array<ModuleInputType>;
};


export type MutationUpdateCompanyOnlineBookingSettingsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: OnlineBookingSettings;
};


export type MutationUpdateCurrentBranchArgs = {
  branchId: Scalars['Int']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCustomDayArgs = {
  branchId: Scalars['Int']['input'];
  customDayId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input?: InputMaybe<UpdateCustomDayInput>;
};


export type MutationUpdateCustomRoleArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: RoleInput;
  roleId: Scalars['Int']['input'];
};


export type MutationUpdateDismissEmployeeArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  dismissalId: Scalars['Int']['input'];
  input: DismissEmployeeInput;
};


export type MutationUpdateEmployeeArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: EmployeeInput;
};


export type MutationUpdateEmployeePositionArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  input: PositionInput;
  positionId: Scalars['Int']['input'];
};


export type MutationUpdateEmployeeRecordSettingsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: EmployeeRecordSettingsInput;
};


export type MutationUpdateEmployeeServiceRelationArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: EmployeeServiceRelationInput;
  relationId: Scalars['Int']['input'];
};


export type MutationUpdateEmployeeServiceRelationsFromServiceArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: UpdateEmployeeServiceRelationsFromServiceInput;
  serviceId: Scalars['Int']['input'];
};


export type MutationUpdateEmployeeWorkScheduleSettingsArgs = {
  branchId: Scalars['Int']['input'];
  input: EmployeeWorkScheduleSettingInput;
};


export type MutationUpdateLogbookSettingsArgs = {
  branchId: Scalars['Int']['input'];
  input: LogbookSettingInput;
};


export type MutationUpdateMenuArgs = {
  allowArchive?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: MenuInput;
};


export type MutationUpdateMenuCategoryArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: MenuCategoryInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMenuItemArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: MenuItemInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMenuStatusArgs = {
  branchId: Scalars['Int']['input'];
  ignoreValidation: Scalars['Boolean']['input'];
  input: MenuInput;
  menuId: Scalars['Int']['input'];
};


export type MutationUpdateMenuSupplementArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: MenuSupplementInput;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOnlineBookingCompanyAllBranchesArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  enableOnlineBooking: Scalars['Boolean']['input'];
};


export type MutationUpdateProductArgs = {
  branchId: Scalars['Int']['input'];
  input: ProductInput;
  productId: Scalars['Int']['input'];
};


export type MutationUpdateProductCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ProductCategoryNewInput;
};


export type MutationUpdateReviewArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ReviewAdminInput;
};


export type MutationUpdateSalaryPaymentArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: SalaryPaymentInput;
  salaryPaymentId: Scalars['Int']['input'];
};


export type MutationUpdateSaleProductsArgs = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input?: InputMaybe<Array<UpdateSaleProductsContainerInput>>;
};


export type MutationUpdateServiceArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ServiceInput;
};


export type MutationUpdateServiceCategoryNewArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: ServiceCategoryNewInput;
};


export type MutationUpdateServiceCategorySalaryArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: ServiceCategorySalaryInput;
  serviceCategorySalaryId: Scalars['Int']['input'];
};


export type MutationUpdateServiceConnectionArgs = {
  branchId: Scalars['Int']['input'];
  connect: Scalars['Boolean']['input'];
  serviceIds: Array<Scalars['Int']['input']>;
  techMapId: Scalars['Int']['input'];
};


export type MutationUpdateStorageArgs = {
  branchId: Scalars['Int']['input'];
  input: StorageInput;
  storageId: Scalars['Int']['input'];
};


export type MutationUpdateStorageProductHistoryArgs = {
  allowNegative?: InputMaybe<Scalars['Boolean']['input']>;
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input?: InputMaybe<Array<StorageOperationHistoryInput>>;
  operationType: StorageProductRelationHistoryAction;
};


export type MutationUpdateStorageProductRelationArgs = {
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  branchId: Scalars['Int']['input'];
  input: UpdateStorageProductRelationInput;
  storageProductRelationId: Scalars['Int']['input'];
};


export type MutationUpdateTechMapCategoryArgs = {
  branchId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: TechMapCategoryNewInput;
};


export type MutationUpdateTechMapConnectionArgs = {
  branchId: Scalars['Int']['input'];
  connect: Scalars['Boolean']['input'];
  serviceId: Scalars['Int']['input'];
  techMapIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateTechnologicalMapArgs = {
  branchId: Scalars['Int']['input'];
  input: TechnologicalMapInput;
  technologicalMapId: Scalars['Int']['input'];
};


export type MutationUpdateUserArgs = {
  companyId: Scalars['Int']['input'];
  input: UserInput;
  isCompanyNew?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUpdateVacationArgs = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: VacationInput;
  vacationId: Scalars['Int']['input'];
};


export type MutationUpdateWorkScheduleArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  input: WorkScheduleInput;
};


export type MutationUpdateWriteOffProductsArgs = {
  bookingUuid: Scalars['Uuid']['input'];
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  input: ProductWriteOffContainerInput;
  operationNumber?: InputMaybe<Scalars['Uuid']['input']>;
};


export type MutationWriteOffProductsArgs = {
  bookingUuid: Scalars['Uuid']['input'];
  branchId: Scalars['Int']['input'];
  input: ProductWriteOffContainerInput;
};

export type OffDayProxy = {
  __typename?: 'OffDayProxy';
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  workSchedule?: Maybe<WorkScheduleProxy>;
};


export type OffDayProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type OnlineBookingSettings = {
  needsClientRecall?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingDuration?: InputMaybe<DateTimePeriodType>;
};

export type OutOfStockProductsPaginated = {
  __typename?: 'OutOfStockProductsPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<ProductProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaidFeaturePaginated = {
  __typename?: 'PaidFeaturePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  paidFeatures?: Maybe<Array<PaidFeatureProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PaidFeatureProxy = {
  __typename?: 'PaidFeatureProxy';
  company?: Maybe<CompanyProxy>;
  currency?: Maybe<Currency>;
  dateOfEnd?: Maybe<Scalars['String']['output']>;
  dateOfLastPayment: Scalars['String']['output'];
  dateOfStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isYearly: Scalars['Boolean']['output'];
  name?: Maybe<Tariff>;
  paymentOrder?: Maybe<PaymentOrderProxy>;
  paymentOrdersByDate?: Maybe<Array<PaymentOrderProxy>>;
  price: Scalars['Float']['output'];
  status?: Maybe<SubscriptionStatus>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionRegistrationDate?: Maybe<Scalars['String']['output']>;
};


export type PaidFeatureProxyDateOfEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaidFeatureProxyDateOfLastPaymentArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaidFeatureProxyDateOfStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaidFeatureProxySubscriptionRegistrationDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentOrderProxy = {
  __typename?: 'PaymentOrderProxy';
  amount?: Maybe<Scalars['Float']['output']>;
  company?: Maybe<CompanyProxy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  paidFeatures?: Maybe<PaidFeatureProxy>;
  parentOrder?: Maybe<PaymentOrderProxy>;
  paymentOrders?: Maybe<Array<PaymentOrderProxy>>;
  planId: Scalars['Int']['output'];
  status?: Maybe<PaymentOrderStatus>;
  test: Scalars['Boolean']['output'];
  user?: Maybe<UserProxy>;
};


export type PaymentOrderProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentOrderProxyPaymentOrdersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum PaymentOrderStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum PaymentType {
  Card = 'CARD',
  Cash = 'CASH'
}

export enum PermissionScope {
  All = 'ALL',
  Self = 'SELF'
}

export type PhoneCodeProxy = {
  __typename?: 'PhoneCodeProxy';
  code: Scalars['String']['output'];
  country?: Maybe<CountryProxy>;
  id: Scalars['Int']['output'];
};

export type PlanPriceProxy = {
  __typename?: 'PlanPriceProxy';
  eur?: Maybe<Scalars['Float']['output']>;
  planId: Scalars['Int']['output'];
  planName: TariffPlan;
  savingsEur: Scalars['Float']['output'];
  savingsUah?: Maybe<Scalars['Float']['output']>;
  savingsUsd?: Maybe<Scalars['Float']['output']>;
  uah?: Maybe<Scalars['Float']['output']>;
  usd?: Maybe<Scalars['Float']['output']>;
};

export type PositionInput = {
  company: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProductAttributesInput = {
  name: Scalars['String']['input'];
  property: Scalars['String']['input'];
};

export type ProductAttributesProxy = {
  __typename?: 'ProductAttributesProxy';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<ProductProxy>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryNewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryNewPaginated = {
  __typename?: 'ProductCategoryNewPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<ProductCategoryNewProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductCategoryNewProxy = {
  __typename?: 'ProductCategoryNewProxy';
  childCategories?: Maybe<Array<Maybe<ProductCategoryNewProxy>>>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ProductCategoryNewProxy>;
  products?: Maybe<Array<ProductProxy>>;
};


export type ProductCategoryNewProxyChildCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProductCategoryNewProxyProductsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryProxy = {
  __typename?: 'ProductCategoryProxy';
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productSubcategories?: Maybe<Array<ProductSubcategoryProxy>>;
  suppliers?: Maybe<Array<SupplierProxy>>;
};


export type ProductCategoryProxyProductSubcategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductCategoryProxySuppliersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductInput = {
  alternativeUnitGroupInput?: InputMaybe<AlternativeUnitGroupInput>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  brand: Scalars['String']['input'];
  category: Scalars['Int']['input'];
  cost?: InputMaybe<Scalars['Float']['input']>;
  criticalResidue?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isUpdateLogo?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  productAttributes?: InputMaybe<Array<InputMaybe<ProductAttributesInput>>>;
  sku?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['Int']['input'];
  unitGroup: Scalars['Int']['input'];
};

export type ProductPaginated = {
  __typename?: 'ProductPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<ProductProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductParametersProxy = {
  __typename?: 'ProductParametersProxy';
  name: Scalars['String']['output'];
};

export type ProductProxy = {
  __typename?: 'ProductProxy';
  alternativeUnit?: Maybe<UnitProxy>;
  alternativeUnitGroup?: Maybe<UnitGroupProxy>;
  alternativeValue?: Maybe<Scalars['Float']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  cost?: Maybe<Scalars['String']['output']>;
  criticalResidue?: Maybe<Scalars['Int']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
  productAttributes?: Maybe<Array<ProductAttributesProxy>>;
  productCategoryNew?: Maybe<ProductCategoryNewProxy>;
  productStockStatus?: Maybe<Scalars['String']['output']>;
  remnantsPerBranch: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  storageProductRelationHistories?: Maybe<Array<StorageProductRelationProxy>>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  storages?: Maybe<Array<StorageProxy>>;
  subcategory?: Maybe<ProductSubcategoryProxy>;
  techMapProducts?: Maybe<TechMapProductPaginated>;
  technologicalMapProductRelations?: Maybe<Array<TechnologicalMapProductRelationProxy>>;
  unit?: Maybe<UnitProxy>;
  unitGroup?: Maybe<UnitGroupProxy>;
  units?: Maybe<Array<UnitProxy>>;
};


export type ProductProxyProductAttributesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductProxyRemnantsPerBranchArgs = {
  branchId: Scalars['Int']['input'];
};


export type ProductProxyStorageProductRelationHistoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductProxyStorageProductRelationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductProxyStoragesArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductProxyTechMapProductsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  techMapId: Scalars['Int']['input'];
};


export type ProductProxyTechnologicalMapProductRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  techMapId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSaleInput = {
  amount: Scalars['Float']['input'];
  discount?: InputMaybe<Scalars['Int']['input']>;
  price: Scalars['Float']['input'];
  product: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  storage?: InputMaybe<Scalars['Int']['input']>;
  unit: Scalars['Int']['input'];
};

export type ProductSaleRow = {
  __typename?: 'ProductSaleRow';
  amount?: Maybe<Scalars['Float']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  isStockLimitExceeded: Scalars['Boolean']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  unitId: Scalars['Int']['output'];
};

export type ProductSaleRowInput = {
  discount?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  storageProductRelation: Scalars['Int']['input'];
  unitId: Scalars['Int']['input'];
};

export type ProductSubcategoryProxy = {
  __typename?: 'ProductSubcategoryProxy';
  category?: Maybe<ProductCategoryProxy>;
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<ProductProxy>>;
  suppliers?: Maybe<Array<SupplierProxy>>;
};


export type ProductSubcategoryProxyProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductSubcategoryProxySuppliersArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductWriteOffContainerInput = {
  bookingUuid: Scalars['String']['input'];
  branch: Scalars['Int']['input'];
  items: Array<ProductWriteOffInput>;
  operationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ProductWriteOffInput = {
  isZeroAccept: Scalars['Boolean']['input'];
  product: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  storage: Scalars['Int']['input'];
  techMap?: InputMaybe<Scalars['Int']['input']>;
  unit: Scalars['Int']['input'];
};

export type QualificationConfirmationProxy = {
  __typename?: 'QualificationConfirmationProxy';
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  TechMapCategories?: Maybe<TechMapCategoryNewPaginated>;
  bookingAllowedDurations: Array<Maybe<BookingAllowedDurationProxy>>;
  bookingStatus: Array<BookingStatusProxy>;
  branch?: Maybe<BranchProxy>;
  branchBarcodes: Array<Maybe<ProductParametersProxy>>;
  branchBrands: Array<Maybe<ProductParametersProxy>>;
  branchProductCategories?: Maybe<Array<Maybe<ProductCategoryNewProxy>>>;
  branchSKUs: Array<Maybe<ProductParametersProxy>>;
  branchTypes: Array<BranchTypeProxy>;
  company?: Maybe<Company>;
  companyBranches: Array<BranchProxy>;
  companyBrands: Array<Maybe<ProductParametersProxy>>;
  countryGeo?: Maybe<CountryGeoProxy>;
  day: Array<DayProxy>;
  dismissalReason: Array<EmployeeDismissalReasonProxy>;
  employeeSpecializations: Array<Maybe<EmployeeSpecializationProxy>>;
  employeeStatus: Array<EmployeeStatusProxy>;
  gender: Array<GenderProxy>;
  isAnyBookingsPerDateRange?: Maybe<Array<BranchProxy>>;
  job: JobContainerProxy;
  loginCompanies?: Maybe<Array<LoginCompany>>;
  me?: Maybe<Me>;
  menuAllergens: Array<MenuAllergenProxy>;
  menuMarkers: Array<MenuMarkerProxy>;
  menuStatuses: Array<MenuStatusProxy>;
  menuTypes: Array<MenuTypeProxy>;
  planPrice: Array<PlanPriceProxy>;
  productCategories?: Maybe<ProductCategoryNewPaginated>;
  productSaleRow: ProductSaleRow;
  products?: Maybe<ProductPaginated>;
  relations: RelationProxy;
  role: RolePaginated;
  roleAccessList: Array<CompanyAccessProxy>;
  rolePermissions: Scalars['Boolean']['output'];
  serviceCategories?: Maybe<ServiceCategoryNewPaginated>;
  storageReports?: Maybe<StorageReportPaginated>;
  suppliers: Array<Maybe<SupplierProxy>>;
  test: Scalars['String']['output'];
  usableRole: Scalars['Boolean']['output'];
  user?: Maybe<UserProxy>;
  writeOffReasons: Array<Maybe<WriteOffReasonProxy>>;
};


export type QueryTechMapCategoriesArgs = {
  branchId: Scalars['Int']['input'];
  categoryName?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBranchArgs = {
  id: Scalars['ID']['input'];
  ignoreValidation?: InputMaybe<Scalars['Boolean']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBranchBarcodesArgs = {
  branchId: Scalars['Int']['input'];
};


export type QueryBranchBrandsArgs = {
  branchId: Scalars['Int']['input'];
};


export type QueryBranchProductCategoriesArgs = {
  branchId: Scalars['Int']['input'];
};


export type QueryBranchSkUsArgs = {
  branchId: Scalars['Int']['input'];
};


export type QueryBranchTypesArgs = {
  branchId: Scalars['Int']['input'];
  onlyBarberShop?: InputMaybe<Scalars['Boolean']['input']>;
  onlyChild?: InputMaybe<Scalars['Boolean']['input']>;
  onlyMeMenu?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
  ignoreValidation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyBranchesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyBrandsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
};


export type QueryCountryGeoArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmployeeSpecializationsArgs = {
  branchId: Scalars['Int']['input'];
};


export type QueryIsAnyBookingsPerDateRangeArgs = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryJobArgs = {
  branchId: Scalars['Int']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
  entities?: InputMaybe<Array<InputMaybe<JobEntity>>>;
  status?: InputMaybe<JobStatus>;
};


export type QueryLoginCompaniesArgs = {
  email: Scalars['String']['input'];
};


export type QueryPlanPriceArgs = {
  period?: InputMaybe<TariffPeriod>;
};


export type QueryProductCategoriesArgs = {
  branchId: Scalars['Int']['input'];
  categoryName?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductSaleRowArgs = {
  branchId: Scalars['Int']['input'];
  input: ProductSaleRowInput;
};


export type QueryProductsArgs = {
  branchId: Scalars['Int']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId: Scalars['Int']['input'];
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  needsFilterByBranch?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  stockStatus?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRoleArgs = {
  branchId: Scalars['Int']['input'];
  excludeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRoleAccessListArgs = {
  branchId: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
};


export type QueryRolePermissionsArgs = {
  branchId: Scalars['Int']['input'];
  input: RolePermissionInput;
};


export type QueryServiceCategoriesArgs = {
  branchId: Scalars['Int']['input'];
  categoryName?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStorageReportsArgs = {
  branchId: Scalars['Int']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientId?: InputMaybe<Scalars['Int']['input']>;
  employee: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['Date']['input'];
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reportType: StorageReportType;
  sku_barcode?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuppliersArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
};


export type QueryTestArgs = {
  name: Scalars['String']['input'];
};


export type QueryUsableRoleArgs = {
  branchId: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  translationLocale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWriteOffReasonsArgs = {
  branchId: Scalars['Int']['input'];
  companyId: Scalars['Int']['input'];
};

export type RecordSettingProxy = {
  __typename?: 'RecordSettingProxy';
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  isDefaultEmployee: Scalars['Boolean']['output'];
  isOnlineSignUpAvailable: Scalars['Boolean']['output'];
  isReviewsAvailable: Scalars['Boolean']['output'];
  isShowSurname: Scalars['Boolean']['output'];
};

export type RelationProxy = {
  __typename?: 'RelationProxy';
  alternativeUnitGroups?: Maybe<Array<Maybe<UnitGroupProxy>>>;
  cities?: Maybe<Array<CityProxy>>;
  countries?: Maybe<Array<CountryProxy>>;
  currencies?: Maybe<Array<CurrencyProxy>>;
  days?: Maybe<Array<DayProxy>>;
  languages?: Maybe<Array<LanguageProxy>>;
  mainUnits?: Maybe<Array<Maybe<UnitProxy>>>;
  menuCategoryIcons?: Maybe<Array<MenuCategoryIconProxy>>;
  modules?: Maybe<Array<Maybe<ModuleProxy>>>;
  storageTypes?: Maybe<Array<StorageTypeProxy>>;
  timezones?: Maybe<Array<TimeZoneProxy>>;
  translatedLanguages?: Maybe<Array<LanguageProxy>>;
  units?: Maybe<Array<UnitProxy>>;
  writeOffReasons?: Maybe<Array<WriteOffReasonProxy>>;
};


export type RelationProxyAlternativeUnitGroupsArgs = {
  unitId: Scalars['Int']['input'];
};


export type RelationProxyCitiesArgs = {
  countryId: Scalars['Int']['input'];
};


export type RelationProxyCountriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RelationProxyLanguagesArgs = {
  isMessageOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RelationProxyTimezonesArgs = {
  countryId?: InputMaybe<Scalars['Int']['input']>;
};

export type ReviewAdminInput = {
  name: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewPaginated = {
  __typename?: 'ReviewPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<ReviewProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ReviewProxy = {
  __typename?: 'ReviewProxy';
  booking?: Maybe<BookingMainProxy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


export type ReviewProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type RoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<RolePermissionInput>>;
};

export type RolePaginated = {
  __typename?: 'RolePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<RoleProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RolePermissionInput = {
  action: CompanyAccess;
  scope?: InputMaybe<PermissionScope>;
};

export type RoleProxy = {
  __typename?: 'RoleProxy';
  branch?: Maybe<BranchProxy>;
  company?: Maybe<CompanyProxy>;
  companyAccesses?: Maybe<Array<CompanyAccessProxy>>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  userBranchRelations?: Maybe<Array<UserBranchRelationProxy>>;
  userCompanyRelations?: Maybe<Array<UserCompanyRelationProxy>>;
};


export type RoleProxyUserBranchRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RoleProxyUserCompanyRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type SalaryPaymentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
};

export type SalaryPaymentPaginated = {
  __typename?: 'SalaryPaymentPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  salaryPayments?: Maybe<Array<SalaryPaymentProxy>>;
  totalBookingsAmount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SalaryPaymentProxy = {
  __typename?: 'SalaryPaymentProxy';
  bookings?: Maybe<BookingPaginated>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  paymentValue?: Maybe<Scalars['Float']['output']>;
  periodEnd?: Maybe<Scalars['String']['output']>;
  periodStart?: Maybe<Scalars['String']['output']>;
};


export type SalaryPaymentProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  salaryPaymentId?: InputMaybe<Scalars['Int']['input']>;
  salaryValue?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type SalaryPaymentProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type SalaryPaymentProxyPeriodEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type SalaryPaymentProxyPeriodStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum SalaryType {
  Currency = 'CURRENCY',
  Percent = 'PERCENT'
}

export type ServiceBookingProxy = {
  __typename?: 'ServiceBookingProxy';
  currencyCode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  serviceCategoryNew?: Maybe<ServiceCategoryNewProxy>;
};


export type ServiceBookingProxyDurationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCategoryNewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceCategoryNewPaginated = {
  __typename?: 'ServiceCategoryNewPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<ServiceCategoryNewProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServiceCategoryNewProxy = {
  __typename?: 'ServiceCategoryNewProxy';
  childCategories?: Maybe<Array<Maybe<ServiceCategoryNewProxy>>>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<ServiceCategoryNewProxy>;
  services?: Maybe<Array<ServiceProxy>>;
};


export type ServiceCategoryNewProxyChildCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ServiceCategoryNewProxyServicesArgs = {
  bookingUuid?: InputMaybe<Scalars['Uuid']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  dateTime?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceCategorySalaryInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  salaryType: SalaryType;
  salaryValue: Scalars['Float']['input'];
  selectedAllCategories: Scalars['Boolean']['input'];
  serviceCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceCategorySalaryProxy = {
  __typename?: 'ServiceCategorySalaryProxy';
  deleted: Scalars['Boolean']['output'];
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  salaryType?: Maybe<Scalars['Int']['output']>;
  salaryValue?: Maybe<Scalars['Float']['output']>;
  selectedAll: Scalars['Boolean']['output'];
  serviceCategory?: Maybe<Array<ServiceCategoryNewProxy>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type ServiceCategorySalaryProxyUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceEmployeesPaginated = {
  __typename?: 'ServiceEmployeesPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  serviceEmployees?: Maybe<Array<EmployeeProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServiceInput = {
  allowDeleteDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  category: Scalars['Int']['input'];
  company: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  isUpdateImage?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  onlineBooking: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  subcategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ServicePaginated = {
  __typename?: 'ServicePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<ServiceProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ServiceProxy = {
  __typename?: 'ServiceProxy';
  bookings?: Maybe<BookingPaginated>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  employeeServiceRelations?: Maybe<Array<EmployeeServiceRelationProxy>>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onlineRegistration: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  serviceCategoryNew?: Maybe<ServiceCategoryNewProxy>;
  serviceEmployees?: Maybe<ServiceEmployeesPaginated>;
  serviceEmployeesList?: Maybe<Array<EmployeeProxy>>;
  technologicalMapServiceRelations?: Maybe<Array<TechnologicalMapServiceRelationProxy>>;
};


export type ServiceProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceProxyDurationArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type ServiceProxyEmployeeServiceRelationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceProxyServiceEmployeesArgs = {
  branchId: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  employeePosition?: InputMaybe<Scalars['Int']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  filterByService?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type ServiceProxyServiceEmployeesListArgs = {
  branchId: Scalars['Int']['input'];
  employeeName?: InputMaybe<Scalars['String']['input']>;
  employeePosition?: InputMaybe<Scalars['Int']['input']>;
  filterByService?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceProxyTechnologicalMapServiceRelationsArgs = {
  connect?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  techMapId?: InputMaybe<Scalars['Int']['input']>;
};

export type StorageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  storageType: Scalars['Int']['input'];
};

export type StorageOperationHistoryInput = {
  storageProductRelationHistoryId: Scalars['Int']['input'];
  updateStorageProductRelationHistoryInputType?: InputMaybe<UpdateStorageProductHistoryInput>;
};

export type StorageOperationInput = {
  storageProductRelationId: Scalars['Int']['input'];
  updateStorageProductRelationInput?: InputMaybe<UpdateStorageProductRelationInput>;
};

export type StoragePaginated = {
  __typename?: 'StoragePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  storages?: Maybe<Array<StorageProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageProductOperationHistoryDataProxy = {
  __typename?: 'StorageProductOperationHistoryDataProxy';
  alternativeUnit?: Maybe<UnitProxy>;
  client?: Maybe<ClientProxy>;
  employee?: Maybe<EmployeeProxy>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  operationHistory?: Maybe<StorageProductOperationHistoryProxy>;
  storage?: Maybe<StorageProxy>;
  unit?: Maybe<UnitProxy>;
  value?: Maybe<Scalars['String']['output']>;
};

export type StorageProductOperationHistoryProxy = {
  __typename?: 'StorageProductOperationHistoryProxy';
  changeTime?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  exists: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  storageProductOperationHistoryData?: Maybe<Array<StorageProductOperationHistoryDataProxy>>;
  storageProductRelationHistory?: Maybe<StorageProductRelationHistoryProxy>;
};


export type StorageProductOperationHistoryProxyChangeTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type StorageProductOperationHistoryProxyStorageProductOperationHistoryDataArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type StorageProductPaginated = {
  __typename?: 'StorageProductPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum StorageProductRelationActionType {
  Arrival = 'ARRIVAL',
  BookingWriteOff = 'BOOKING_WRITE_OFF',
  Movement = 'MOVEMENT',
  Sale = 'SALE',
  WriteOff = 'WRITE_OFF'
}

export enum StorageProductRelationHistoryAction {
  Arrival = 'ARRIVAL',
  BookingWriteOff = 'BOOKING_WRITE_OFF',
  Movement = 'MOVEMENT',
  Sale = 'SALE',
  WriteOff = 'WRITE_OFF'
}

export type StorageProductRelationHistoryPaginatedType = {
  __typename?: 'StorageProductRelationHistoryPaginatedType';
  currentPage?: Maybe<Scalars['Int']['output']>;
  entities?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StorageProductRelationHistoryProxy = {
  __typename?: 'StorageProductRelationHistoryProxy';
  action?: Maybe<StorageProductRelationHistoryAction>;
  amount?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<BookingMainProxy>;
  client?: Maybe<ClientProxy>;
  comment?: Maybe<Scalars['String']['output']>;
  cost: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  edited: Scalars['Boolean']['output'];
  employee?: Maybe<EmployeeProxy>;
  historyAction?: Maybe<StorageProductRelationHistoryAction>;
  historyCreator?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  mainQuantity?: Maybe<Scalars['Float']['output']>;
  mainUnit?: Maybe<UnitProxy>;
  operationHistories?: Maybe<Array<StorageProductOperationHistoryProxy>>;
  operationNumber?: Maybe<Scalars['Uuid']['output']>;
  operationNumberReadable?: Maybe<Scalars['String']['output']>;
  operationQuantity?: Maybe<Scalars['Float']['output']>;
  operationUnit?: Maybe<UnitProxy>;
  paymentType?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  product?: Maybe<ProductProxy>;
  quantity?: Maybe<Scalars['BigInt']['output']>;
  quantityForRender?: Maybe<Scalars['String']['output']>;
  relatedSaleHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  relationStorage?: Maybe<StorageProxy>;
  remnants?: Maybe<Scalars['BigInt']['output']>;
  remnantsForRender?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<StorageProxy>;
  supplier?: Maybe<SupplierProxy>;
  techMap?: Maybe<TechnologicalMapProxy>;
  unit?: Maybe<UnitProxy>;
  user?: Maybe<UserProxy>;
  writeOffEditUnits?: Maybe<Array<UnitProxy>>;
  writeOffReason?: Maybe<WriteOffReasonProxy>;
};


export type StorageProductRelationHistoryProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type StorageProductRelationProxy = {
  __typename?: 'StorageProductRelationProxy';
  comment?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mainQuantity?: Maybe<Scalars['Float']['output']>;
  mainUnit?: Maybe<UnitProxy>;
  product?: Maybe<ProductProxy>;
  quantity?: Maybe<Scalars['BigInt']['output']>;
  quantityForRender?: Maybe<Scalars['String']['output']>;
  stockQuantity?: Maybe<Scalars['String']['output']>;
  storage?: Maybe<StorageProxy>;
  unit?: Maybe<UnitProxy>;
  unitGroup?: Maybe<UnitGroupProxy>;
};

export type StorageProxy = {
  __typename?: 'StorageProxy';
  branch?: Maybe<BranchProxy>;
  default: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outOfStockProducts?: Maybe<OutOfStockProductsPaginated>;
  relatedStorageProductRelationHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  storageProductRelationHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  storageProducts?: Maybe<StorageProductPaginated>;
  type?: Maybe<StorageTypeProxy>;
};


export type StorageProxyOutOfStockProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyRelatedStorageProductRelationHistoriesArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyStorageProductRelationHistoriesArgs = {
  branchId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyStorageProductRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type StorageProxyStorageProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  stockStatus?: InputMaybe<Scalars['String']['input']>;
};

export type StorageReportItemOperationProxy = {
  __typename?: 'StorageReportItemOperationProxy';
  amount?: Maybe<Scalars['String']['output']>;
  client?: Maybe<ClientProxy>;
  cost?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  destinationWarehouse?: Maybe<StorageProxy>;
  employee?: Maybe<EmployeeProxy>;
  operationEmployee?: Maybe<EmployeeProxy>;
  price?: Maybe<Scalars['String']['output']>;
  profit?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['String']['output'];
  type: Scalars['String']['output'];
  warehouse?: Maybe<StorageProxy>;
};


export type StorageReportItemOperationProxyDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type StorageReportItemProxy = {
  __typename?: 'StorageReportItemProxy';
  operations?: Maybe<Array<StorageReportItemOperationProxy>>;
  product?: Maybe<ProductProxy>;
  totalAmount?: Maybe<Scalars['String']['output']>;
  totalArrivalQuantity?: Maybe<Scalars['String']['output']>;
  totalCost?: Maybe<Scalars['String']['output']>;
  totalMovementQuantity?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['String']['output']>;
  totalProfit?: Maybe<Scalars['String']['output']>;
  totalSaleQuantity?: Maybe<Scalars['String']['output']>;
  totalWriteOffQuantity?: Maybe<Scalars['String']['output']>;
};


export type StorageReportItemProxyOperationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type StorageReportJobProxy = {
  __typename?: 'StorageReportJobProxy';
  company: CompanyProxy;
  createdAt?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobType: JobType;
  status?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};


export type StorageReportJobProxyCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type StorageReportPaginated = {
  __typename?: 'StorageReportPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<StorageReportItemProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum StorageReportType {
  Arrival = 'ARRIVAL',
  ArrivalWriteOff = 'ARRIVAL_WRITE_OFF',
  Movement = 'MOVEMENT',
  Sale = 'SALE',
  WriteOff = 'WRITE_OFF'
}

export type StorageTypeProxy = {
  __typename?: 'StorageTypeProxy';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storages?: Maybe<Array<StorageProxy>>;
};


export type StorageTypeProxyStoragesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Paused = 'PAUSED'
}

export type SupplierProxy = {
  __typename?: 'SupplierProxy';
  company: CompanyProxy;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum Tariff {
  BaseModule = 'BASE_MODULE',
  MenuModule = 'MENU_MODULE',
  ServicesModule = 'SERVICES_MODULE',
  TariffLite = 'TARIFF_LITE',
  TariffPremium = 'TARIFF_PREMIUM',
  TariffStarter = 'TARIFF_STARTER',
  WarehousesModule = 'WAREHOUSES_MODULE'
}

export enum TariffPeriod {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export enum TariffPlan {
  LiteMonthly = 'LITE_MONTHLY',
  LiteYearly = 'LITE_YEARLY',
  PremiumMonthly = 'PREMIUM_MONTHLY',
  PremiumYearly = 'PREMIUM_YEARLY',
  WarehouseMonthly = 'WAREHOUSE_MONTHLY',
  WarehouseYearly = 'WAREHOUSE_YEARLY'
}

export type TechMapCategoryNewInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type TechMapCategoryNewPaginated = {
  __typename?: 'TechMapCategoryNewPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<TechMapCategoryNewProxy>>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechMapCategoryNewProxy = {
  __typename?: 'TechMapCategoryNewProxy';
  childCategories?: Maybe<Array<Maybe<TechMapCategoryNewProxy>>>;
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentCategory?: Maybe<TechMapCategoryNewProxy>;
  techMaps?: Maybe<Array<TechnologicalMapProxy>>;
};


export type TechMapCategoryNewProxyChildCategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type TechMapCategoryNewProxyTechMapsArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TechMapProductInput = {
  requiredQuantity?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['Int']['input']>;
};

export type TechMapProductPaginated = {
  __typename?: 'TechMapProductPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  techMapProducts?: Maybe<Array<TechnologicalMapProductRelationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechMapServicePaginated = {
  __typename?: 'TechMapServicePaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  techMapServices?: Maybe<Array<TechnologicalMapServiceRelationProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechnologicalMapCategoryProxy = {
  __typename?: 'TechnologicalMapCategoryProxy';
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  technologicalMapSubcategories?: Maybe<Array<TechnologicalMapSubcategoryProxy>>;
};


export type TechnologicalMapCategoryProxyTechnologicalMapSubcategoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TechnologicalMapInput = {
  categoryId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TechnologicalMapPaginated = {
  __typename?: 'TechnologicalMapPaginated';
  currentPage?: Maybe<Scalars['Int']['output']>;
  itemsPerPage?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['String']['output']>;
  technologicalMaps?: Maybe<Array<TechnologicalMapProxy>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TechnologicalMapProductRelationProxy = {
  __typename?: 'TechnologicalMapProductRelationProxy';
  id: Scalars['Int']['output'];
  product?: Maybe<ProductProxy>;
  requiredQuantity?: Maybe<Scalars['Int']['output']>;
  technologicalMap?: Maybe<TechnologicalMapProxy>;
  unit?: Maybe<UnitProxy>;
};

export type TechnologicalMapProxy = {
  __typename?: 'TechnologicalMapProxy';
  bookings?: Maybe<BookingPaginated>;
  company?: Maybe<CompanyProxy>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  getProducts?: Maybe<AddProductTechMapPaginated>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storageProductRelationHistoryList?: Maybe<Array<StorageProductRelationHistoryProxy>>;
  techMapProducts?: Maybe<TechMapProductPaginated>;
  techMapServices?: Maybe<TechMapServicePaginated>;
  technologicalMapNewCategory?: Maybe<TechMapCategoryNewProxy>;
  technologicalMapProductRelations?: Maybe<Array<TechnologicalMapProductRelationProxy>>;
  technologicalMapServiceRelations?: Maybe<Array<TechnologicalMapServiceRelationProxy>>;
  technologicalMapSubcategory?: Maybe<TechnologicalMapSubcategoryProxy>;
};


export type TechnologicalMapProxyBookingsArgs = {
  branchId: Scalars['Int']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  clientInputType?: InputMaybe<ClientQueryInput>;
  completedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  filterByCompany?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  removeCanceledBookings?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
};


export type TechnologicalMapProxyGetProductsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  nameSkuBarcode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type TechnologicalMapProxyStorageProductRelationHistoryListArgs = {
  branch: Scalars['Int']['input'];
  operationNumber: Scalars['Uuid']['input'];
};


export type TechnologicalMapProxyTechMapProductsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
};


export type TechnologicalMapProxyTechMapServicesArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['String']['input']>;
  itemsPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type TechnologicalMapProxyTechnologicalMapProductRelationsArgs = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inStockProducts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TechnologicalMapProxyTechnologicalMapServiceRelationsArgs = {
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['Int']['input']>;
};

export type TechnologicalMapServiceRelationProxy = {
  __typename?: 'TechnologicalMapServiceRelationProxy';
  connect: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  service?: Maybe<ServiceProxy>;
  technologicalMap?: Maybe<TechnologicalMapProxy>;
};

export type TechnologicalMapSubcategoryProxy = {
  __typename?: 'TechnologicalMapSubcategoryProxy';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  technologicalMapCategory?: Maybe<TechnologicalMapCategoryProxy>;
  technologicalMaps?: Maybe<Array<TechnologicalMapProxy>>;
};


export type TechnologicalMapSubcategoryProxyTechnologicalMapsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeZoneProxy = {
  __typename?: 'TimeZoneProxy';
  branches?: Maybe<Array<BranchProxy>>;
  companies?: Maybe<Array<CompanyProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type TimeZoneProxyBranchesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type TimeZoneProxyCompaniesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TranslationProxy = {
  __typename?: 'TranslationProxy';
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UnitGroupProxy = {
  __typename?: 'UnitGroupProxy';
  alternativeProducts?: Maybe<Array<ProductProxy>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  products?: Maybe<Array<ProductProxy>>;
  storageProductRelations?: Maybe<Array<StorageProductRelationProxy>>;
  units?: Maybe<Array<UnitProxy>>;
};


export type UnitGroupProxyAlternativeProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type UnitGroupProxyProductsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type UnitGroupProxyStorageProductRelationsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type UnitGroupProxyUnitsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type UnitProxy = {
  __typename?: 'UnitProxy';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  unitGroup?: Maybe<UnitGroupProxy>;
  unitOrder?: Maybe<Scalars['Int']['output']>;
};

export type UpdateCustomDayInput = {
  customDayPeriods?: InputMaybe<Array<InputMaybe<CustomDayPeriodInput>>>;
};

export type UpdateEmployeeServiceRelationsFromServiceInput = {
  durationOldValue?: InputMaybe<Scalars['String']['input']>;
  onlineOldValue?: InputMaybe<Scalars['Boolean']['input']>;
  priceOldValue?: InputMaybe<Scalars['Float']['input']>;
  updateOption: UpdateEmployeeServiceRelationsOptionsType;
};

export enum UpdateEmployeeServiceRelationsOptionsType {
  AddDelta = 'ADD_DELTA',
  SetAbsolute = 'SET_ABSOLUTE'
}

export type UpdateSaleProductsContainerInput = {
  bookingUuid?: InputMaybe<Scalars['String']['input']>;
  branch: Scalars['Int']['input'];
  client?: InputMaybe<ClientAdminBookingInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  employee: Scalars['Int']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  operationNumber: Scalars['String']['input'];
  paymentType?: InputMaybe<PaymentType>;
  products?: InputMaybe<Array<ProductSaleInput>>;
};

export type UpdateStorageProductHistoryInput = {
  client?: InputMaybe<ClientSaleUpdateInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  employee?: InputMaybe<Scalars['Int']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  moveAll?: InputMaybe<Scalars['Boolean']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  saleProduct?: InputMaybe<ProductSaleInput>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['Int']['input']>;
  writeOffReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStorageProductRelationInput = {
  action: StorageProductRelationActionType;
  client?: InputMaybe<ClientAdminBookingInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  destinationStorage?: InputMaybe<Scalars['Int']['input']>;
  employee?: InputMaybe<Scalars['Int']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  quantity: Scalars['Int']['input'];
  saleProduct?: InputMaybe<ProductSaleInput>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  unit: Scalars['Int']['input'];
  writeOffReason?: InputMaybe<Scalars['String']['input']>;
};

export type UserBranchRelationInput = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
};

export type UserBranchRelationProxy = {
  __typename?: 'UserBranchRelationProxy';
  branch: BranchProxy;
  employee: EmployeeProxy;
  id: Scalars['Int']['output'];
  role: RoleProxy;
};

export type UserCompanyRelationProxy = {
  __typename?: 'UserCompanyRelationProxy';
  company?: Maybe<CompanyProxy>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  role?: Maybe<RoleProxy>;
};

export type UserInput = {
  currentBranch: Scalars['Int']['input'];
};

export type UserProxy = {
  __typename?: 'UserProxy';
  companies?: Maybe<Array<CompanyProxy>>;
  company?: Maybe<CompanyProxy>;
  currentBranch?: Maybe<BranchProxy>;
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  id: Scalars['Int']['output'];
  isUserActiveWithinTariff?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleProxy>;
  roles: Array<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};


export type UserProxyCompanyArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
};


export type UserProxyEmployeeArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxyIsUserActiveWithinTariffArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxyNameArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxyRoleArgs = {
  companyId: Scalars['Int']['input'];
};


export type UserProxySurnameArgs = {
  companyId: Scalars['Int']['input'];
};

export type VacationInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  type: VacationType;
};

export type VacationProxy = {
  __typename?: 'VacationProxy';
  employee?: Maybe<EmployeeProxy>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<VacationType>;
};


export type VacationProxyEndDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type VacationProxyStartDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export enum VacationType {
  Absenteeism = 'ABSENTEEISM',
  Holiday = 'HOLIDAY',
  PaidDayOff = 'PAID_DAY_OFF',
  SickLeave = 'SICK_LEAVE',
  UnpaidDayOff = 'UNPAID_DAY_OFF'
}

export type WorkScheduleInput = {
  branchId: Scalars['Int']['input'];
  employeeId: Scalars['Int']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  workingDayPeriods: Array<WorkingDayPeriodInput>;
};

export type WorkScheduleProxy = {
  __typename?: 'WorkScheduleProxy';
  branch?: Maybe<BranchProxy>;
  editUrl?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<EmployeeProxy>;
  employeeLogbookUrl?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  offDays?: Maybe<Array<OffDayProxy>>;
  startDate: Scalars['String']['output'];
  workingDayPeriods: Array<Maybe<WorkingDayPeriodProxy>>;
};


export type WorkScheduleProxyEndDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WorkScheduleProxyOffDaysArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkScheduleProxyStartDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WorkScheduleProxyWorkingDayPeriodsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkingDayPeriodInput = {
  dayId: Scalars['Int']['input'];
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
};

export type WorkingDayPeriodProxy = {
  __typename?: 'WorkingDayPeriodProxy';
  day?: Maybe<DayProxy>;
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  workSchedule?: Maybe<WorkScheduleProxy>;
};


export type WorkingDayPeriodProxyEndTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type WorkingDayPeriodProxyStartTimeArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type WriteOffReasonProxy = {
  __typename?: 'WriteOffReasonProxy';
  company?: Maybe<CompanyProxy>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  storageProductRelationHistories?: Maybe<Array<StorageProductRelationHistoryProxy>>;
};


export type WriteOffReasonProxyStorageProductRelationHistoriesArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};
